import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",

    resources: {

      fr: {
        translation: {
          home: "Accueil",
          buyCar: "Acheter une voiture",
          sellCar: "Vendre",
          featuredCars: "Voitures en vente",
          cars: "Voitures",
          or: "ou",
          login: "Connexion",
          loginOut: "Déconnexion",
          register: "Inscription",
          offers: "offres",
          sort: "Trier",
          contactSeller: "Contacter le vendeur",
          mileage: "Kilométrage",
          transmission: "Transmission",
          year: "Année",
          fuelType: "Type de carburant",
          power: "Puissance",
          seller: "Vendeur",
          price: "Prix",
          publishedOn: "il y a",
          status: "Statut",
          phoneNumber: "N° de téléphone",
          loading: "Chargement...",
          noCarsFound: "Aucune voiture trouvée",
          noResults: "Aucun résultat",
          allBrands: "toutes les marques",
          allModels: "tous les modèles",
          allGenerations: "toutes les générations",
          standardResults: "Résultats standards",
          priceAscending: "Prix croissant",
          priceDescending: "Prix décroissant",
          mostRecent: "Plus récentes",
          lowMileage: "Kilométrage faible",
          veryGoodPrice: "Très bon prix",
          diesel: "Diesel",
          for: "pour",
          priceNotSpecified: "Prix non spécifié",
          messageBtn: "Message",
          postedToday: "Aujourd'hui",
          postedYesterday: "Hier",
          postedDaysAgo: "il y a {{count}} jours",
          postedOneWeekAgo: "il y a 1 semaine",
          postedWeeksAgo: "il y a {{count}} semaines",
          postedOneMonthAgo: "il y a 1 mois",
          postedMonthsAgo: "il y a {{count}} mois",
          share: "Partager",
          print: "Imprimer",
          basicData: "Données de base",
          vehicleHistory: "Historique du véhicule",
          technicalSpecs: "Caractéristiques Techniques",
          colorsInterior: "Couleur et Garnissage Intérieur",
          bodyType: "Type de carrosserie",
          motoType: "Type de moto",
          utilitaireBodyType: "Carrosserie",
          payloadCapacity: "Charge utile",
          cargoVolume: "Volume utile",
          vehicleType: "Type de véhicule",
          condition: "État",
          doors: "Nombre de portes",
          warranty: "Garantie",
          previousOwners: "Nombre de propriétaires précédents",
          smoker: "Fumeur",
          engineCapacity: "Cylindrée",
          gears: "Vitesses",
          exteriorColor: "Couleur extérieure",
          paintType: "Type de peinture",
          interiorColor: "Couleur intérieure",
          interior: "Intérieur",
          country: "Pays",
          seats: "Nombre de sièges",
          carCharacteristics: "Caractéristiques",
          equipment: "Équipements",
          images: "Images",
          yourName: "Votre nom",
          yourEmail: "Votre e-mail",
          listingNumber: "N° d'annonce",
          yourPhone: "Votre téléphone",
          acceptData: "J'accepte le traitement de mes données",
          defaultContactMessage: `Bonjour,

            Je suis intéressé(e) par votre véhicule. Est-il toujours disponible ?

            Cordialement,`,
          km: "km",
          hp: "ch",
          brand: "Marque",
          model: "Modèle",
          generation: "Génération",
          popularBrands: "Marques populaires",
          maxPrice: "Prix jusque (DH)",
          promoUsedCars: "VOITURES D'OCCASION EN PROMOTION",
          selectMaxPrice: "Sélectionnez un prix maximum",
          firstRegistration: "1ère immatriculation",
          results: "résultats",
          resultsLoading: "résultats...",
          browseBy: "Parcourir par",
          topBrands: "Marques populaires",
          heroTitle: "Trouvez votre voiture idéale",
          heroSub: "Des milliers d'annonces vérifiées au Maroc",
          vehicleTypes: {
            cars: "Voitures",
            caravans: "Caravanes",
            vans: "Véhicules utilitaires",
            trucks: "Camions",
            trailers: "Remorques",
            motorcycles: "Motos",
            comingSoon: "Bientôt disponible",
          },
          otherBrands: "Autres marques",
          searchBtn: "Rechercher",
          seeResults: "Voir {{count}} annonce",
          seeResultsPlural: "Voir {{count}} annonces",
          languageChanged: "Langue modifiée",
          searchByBodyType: "Recherche par type de carrosserie",
          citadine: "Citadine",
          suv: "SUV",
          pickup: "Pick-up",
          utility: "Utilitaire",
          convertible: "Cabriolet",
          minivan: "Monospace",
          searchByBrand: "Recherche par marque",
          sedan: "Berline",
          stationWagon: "Break",
          coupe: "Coupé",
          loginWith: "Se connecter avec",
          emailAddress: "Adresse e-mail",
          password: "Mot de passe",
          forgotPassword: "Mot de passe oublié ?",
          dontHaveAccount: "Vous n'avez pas de compte ?",
          signUp: "S'inscrire",
          signUpWithGoogle: "S'inscrire avec Google",
          signUpWithFacebook: "S'inscrire avec Facebook",
          completeYourProProfile: "Compte créé ! Complétez votre profil professionnel pour être visible par les acheteurs.",
          facebookLoginCancelled: "Connexion Facebook annulée.",
          facebookLoginFailed: "La connexion Facebook a échoué. Si l'app est encore en mode développement, vérifiez que votre compte a été ajouté comme testeur.",
          missingToken: "Token manquant",
          loginFailed: "Email ou mot de passe invalide",
          createAccount: "Créer votre compte",
          fullName: "Nom complet",
          alreadyHaveAccount: "Vous avez déjà un compte ?",
          passwordNotMatch: "Les mots de passe ne correspondent pas",
          registerSuccess: "Compte créé avec succès",
          registerError: "Erreur lors de la création du compte",
          emailAlreadyExists: "Un compte existe déjà avec cet email.",
          goToLogin: "Se connecter",
          passwordRequirements: "Au moins 6 caractères.",
          passwordTooWeak: "Mot de passe invalide : " ,
          companyName: "Nom commercial",
          profileTitle: "Mon Profil",
          addPhoto: "Ajouter photo",
          changePhoto: "Changer photo",
          coverPhoto: "Photo de couverture",
          addCoverPhoto: "Ajouter photo de couverture",
          changeCoverPhoto: "Changer photo de couverture",
          save: "Sauvegarder",
          requiredFields: "Veuillez remplir tous les champs obligatoires, y compris la photo de couverture.",
          profileUpdated: "Profil mis à jour",
          updateError: "Erreur lors de la mise à jour du profil",
          username: "Nom utilisateur",
          city: "Ville",
          particulier: "Particulier",
          professionnel: "Professionnel",
          currency: "DH",
          sendResetLink: "Envoyer le lien",
          resetPasswordSuccess:
            "Si cet email existe, vous recevrez un lien de réinitialisation.",
          forgotPasswordError:
            "Erreur lors de l'envoi du lien",
          resetPassword: "Réinitialiser le mot de passe",
          newPassword: "Nouveau mot de passe",
          confirmPassword: "Confirmer le mot de passe",
          passwordResetSuccess:
            "Mot de passe réinitialisé avec succès",
          resetPasswordFailed:
            "Échec de la réinitialisation du mot de passe",
          backToLogin: "Retour à la connexion",
          yes: "Oui",
          no: "Non",

          /* ── Dashboard / MyCars ── */
          resetFilters: "Réinitialiser les filtres",
          myListings: "Mes annonces",
          newListing: "Nouvelle annonce",
          search: "Rechercher...",
          allTypes: "Tous les types",
          allStatus: "Toutes",
          activeStatus: "Actives",
          inactiveStatus: "Désactivées",
          listingDeleted: "Annonce supprimée",
          confirmDelete: "Êtes-vous sûr de vouloir supprimer cette annonce ?",
          totalListings: "Total annonces",
          activeListingsCount: "Annonces actives",
          totalViews: "Total vues",
          messages: "Messages",
          carColumn: "Voiture",
          views: "Vues",
          actions: "Actions",
          seeListing: "Voir annonce",
          edit: "Modifier",
          deactivate: "Désactiver",
          activate: "Activer",
          delete: "Supprimer",
          activeLabel: "ACTIVE",
          inactiveLabel: "DÉSACTIVÉE",
          notifications: "Notifications",
          noNotifications: "Aucune notification",
          dashboard: "Dashboard",
          addListing: "Ajouter annonce",
          statisticsNav: "Statistiques",
          settings: "Paramètres",
          settingsComingSoon: "Les paramètres seront disponibles bientôt...",
          statisticsViews: "Statistiques des vues",
          myFavorites: "Mes favoris",
          chat: "Chat",
          myAccount: "Mon compte",
          /* ── Header menu ── */
          headerMyListings: "Mes annonces",
          headerFavorites: "Mes favoris",
          headerProfile: "Profil",
          /* ── Misc ── */
          previous: "Précédent",
          next: "Suivant",
          professionalSellers: "Vendeurs Professionnels",
          seeProfile: "Voir le profil",
          carsListed: "annonces",
          description: "Description",
          descriptionPlaceholder: "Décrivez votre activité, vos services...",
          chooseLocation: "Choisir votre localisation",
          myLocation: "Ma position",
          locating: "Localisation...",
          searchAddress: "Rechercher une adresse...",
          confirm: "Confirmer",
          cancel: "Annuler",
          clickAddPhotos: "Cliquez pour ajouter des photos",
          editBackground: "Modifier le fond",
          noFavorites: "Vous n'avez pas encore de favoris",
          removeFavorite: "Retirer des favoris",
          addToFavorites: "Ajouter aux favoris",
          removeFromFavorites: "Retirer des favoris",
          noMessages: "Aucun message pour l'instant",
          selectConversation: "Sélectionnez une conversation",
          typeMessage: "Écrire un message...",
          noDataYet: "Pas encore de données",

          /* ── PromoCars ── */
          promoLabel: "Mise en avant",
          promoCarsTitle: "Annonces boostées",
          seeAllListings: "Voir toutes les annonces",
          promoCardCta: "Voir l'annonce",
          latestListingsLabel: "Fraîchement publiées",
          latestListingsTitle: "Dernières annonces",
          statsListings: "Annonces actives",
          statsSellers: "Vendeurs inscrits",
          statsCities: "Villes couvertes",

          /* ── NewCars / Why section ── */
          ourAdvantages: "Nos avantages",
          whyChooseUs: "Pourquoi choisir Carix ?",
          whyChooseUsSub: "La plateforme la plus complète pour acheter et vendre votre voiture au Maroc.",
          feature1Title: "Recherche intelligente",
          feature1Desc: "Filtrez par marque, modèle, carrosserie, kilométrage, prix et bien plus. Trouvez exactement ce que vous cherchez en quelques clics.",
          feature2Title: "Annonces vérifiées",
          feature2Desc: "Chaque vendeur est vérifié et chaque annonce est contrôlée. Achetez en toute confiance grâce à notre système de validation.",
          feature3Title: "Contact direct",
          feature3Desc: "Échangez directement avec le vendeur via notre messagerie intégrée. Pas d'intermédiaire, pas de commission cachée.",
          feature4Title: "Publication rapide",
          feature4Desc: "Publiez votre annonce en moins de 5 minutes grâce à notre formulaire guidé. Vos photos sont optimisées automatiquement.",

          /* ── Reviews / Testimonials ── */
          testimonialsLabel: "Témoignages",
          testimonialsTitle: "Ce que disent nos utilisateurs",
          member: "Membre",
          testimonialsSub: "Une plateforme pensée pour rendre l'achat et la vente de voitures simples et fiables.",
          statListingsPublished: "Annonces publiées",
          statBuyersSatisfied: "Acheteurs satisfaits",
          statAverageRating: "Note moyenne",
          statSatisfactionRate: "Taux de satisfaction",

          /* ── Misc ── */
          verifiedPartners: "Partenaires vérifiés",
          promoToggleTitle: "Offre spéciale / Promotion",
          promoToggleDesc: "Votre annonce sera mise en avant dans la section \"Offres spéciales\" avec un badge promo.",
          recentlyViewed: "Récemment consultés",

          /* ── Login / Register page ── */
          loginSubtitle: "Accédez à votre compte Carix",
          loginHeroBadge: "Plateforme N°1 au Maroc",
          loginHeroTitle: "Achetez et vendez votre voiture facilement",
          loginHeroSub: "Rejoignez des milliers de particuliers et professionnels qui font confiance à Carix.",
          loginHeroFeature1: "50 000+ véhicules disponibles",
          loginHeroFeature2: "Messagerie intégrée sécurisée",
          loginHeroFeature3: "Annonces vérifiées et fiables",
          heroStatListings: "Annonces",
          heroStatBuyers: "Acheteurs",
          heroStatSatisfaction: "Satisfaction",
          heroLaunchMessage: "Plateforme fraîchement lancée — soyez parmi les premiers à rejoindre Carix et à publier votre annonce.",

          registerSubtitle: "Choisissez votre type de compte",
          particulierDesc: "Vendeur ou acheteur particulier",
          professionnelDesc: "Concessionnaire ou garage",
          sectionInfos: "Informations",
          sectionPresentation: "Présentation",
          sectionSecurity: "Sécurité",
          sectionLocation: "Localisation",
          sectionPhotos: "Photos",
          profilePhotoLabel: "Photo de profil",
          establishmentAddress: "Adresse de votre établissement",

          /* ── ProfilePage ── */
          addressRequired: "Le champ Adresse est obligatoire.",
          companyNameRequiredForSwitch: "Le nom de l'entreprise (champ \"Nom complet\" ci-dessus) est obligatoire.",
          switchToProSuccess: "Votre compte est maintenant un compte Professionnel !",
          switchToProError: "Erreur lors du changement de compte",
          myProfileFallback: "Mon profil",
          personalInfoTitle: "Informations personnelles",
          usernameLabel: "Nom d'utilisateur",
          addressLabel: "Adresse *",
          fieldRequired: "Ce champ est obligatoire",
          addressPlaceholder: "Saisir votre adresse...",
          pointLocation: "Pointer",
          coordinatesLabel: "Coordonnées :",
          switchToProTitle: "Passer en compte Professionnel",
          switchToProDesc: "Vendez en tant que professionnel : page entreprise, description publique et accès aux outils Pro. Le champ \"Nom complet\" ci-dessus sera utilisé comme nom d'entreprise, et votre localisation / photo de couverture actuelles seront conservées. Ajoutez une description de votre activité ci-dessous.",
          switchToProFinalNotice: "Ce changement est définitif.",
          activityDescriptionLabel: "Description de votre activité",
          switchingInProgress: "Changement en cours...",
          becomeProfessionalSeller: "Devenir vendeur Professionnel",
          accountVerificationTitle: "Vérification du compte",
          verifiedAccountBadge: "Compte vérifié",
          verificationPendingBadge: "Demande en cours d'examen",
          verificationPendingDesc: "Votre demande de vérification a bien été reçue. Notre équipe l'examine et revient vers vous sous 48h ouvrées — aucune action supplémentaire n'est requise de votre part.",
          verificationRejectedNotice: "Votre précédente demande n'a pas été validée.",
          rejectionReasonLabel: "Motif :",
          verificationRejectedHint: "Vous pouvez corriger les informations de votre profil ci-dessus puis soumettre une nouvelle demande.",
          verificationBenefitsDesc: "Un compte vérifié affiche un badge de confiance visible par les autres utilisateurs, renforce votre crédibilité et augmente le nombre de contacts reçus. Pour plus de sécurité, nous vous recommandons de faire vérifier votre compte avant de publier vos annonces.",
          verificationRequestSentSuccess: "Demande envoyée ! Notre équipe vous contactera.",
          verificationRequestError: "Erreur lors de la demande",
          resubmitVerificationRequest: "Soumettre une nouvelle demande",
          requestVerificationBtn: "Demander la vérification",

          /* ── SellerProfile ── */
          ratingsCount: "Évaluations",
          previousOwnersLabel: "Propriétaire(s) préc.",
          seeLess: "Voir moins",
          seeMore: "Voir plus",
          searchFor: "Recherche pour",
          carTypeLabel: "Voiture",
          fromLabel: "De",
          toLabel: "À",
          yourMessage: "Votre message",
          sendLabel: "Envoyer",
          memberSince: "Membre depuis",
          close: "Fermer",

          /* ── Settings ── */
          accountDeleteError: "Erreur lors de la suppression.",
          emailNotifLabel: "Notifications par e-mail",
          emailNotifDesc: "Recevoir les nouvelles demandes de contact par e-mail",
          messageNotifLabel: "Notifications de messages",
          messageNotifDesc: "Être alerté des nouveaux messages reçus",
          promoNotifLabel: "Offres & promotions",
          promoNotifDesc: "Recevoir les actualités et offres spéciales de la plateforme",
          securitySection: "Sécurité",
          changePasswordLabel: "Modifier le mot de passe",
          changePasswordDesc: "Changez régulièrement votre mot de passe pour sécuriser votre compte",
          modifyArrowLabel: "Modifier →",
          editProfileLabel: "Modifier le profil",
          editProfileDesc: "Mettre à jour vos informations personnelles et photo de profil",
          languageSection: "Langue",
          dangerZoneTitle: "Zone de danger",
          deleteAccountLabel: "Supprimer mon compte",
          deleteAccountDesc: "Cette action est irréversible. Toutes vos annonces et données seront supprimées.",
          deleteAccountConfirmText: "Êtes-vous sûr ? Cette action supprimera définitivement votre compte et toutes vos annonces.",
          deletingInProgress: "Suppression…",
          confirmAccountDeletion: "Confirmer la suppression",

          /* ── Favorites ── */
          removeFavoriteTitle: "Retirer des favoris ?",
          removeFavoriteContent: "Cette voiture sera retirée de votre liste de favoris.",
          removeLabel: "Retirer",
          listingSingular: "annonce",
          listingPlural: "annonces",
          noFavoritesDesc: "Ajoutez des voitures à vos favoris pour les retrouver ici.",
          browseListings: "Parcourir les annonces",

          /* ── Header ── */
          userFallback: "Utilisateur",
          emailNotConfirmedWarning: "Votre adresse email n'est pas encore confirmée. Vérifiez votre boîte de réception pour activer toutes les fonctionnalités.",
          emailResent: "Email renvoyé",
          sendingInProgress: "Envoi...",
          resendConfirmationEmail: "Renvoyer l'email de confirmation",

          /* ── MultiStepCarForm ── */
          mainPhoto: "Photo principale",
          mainLabel: "Principale",
          setAsMainPhoto: "Définir comme photo principale",
          removeBackground: "Supprimer l'arrière-plan",
          confirmDeletePhoto: "Supprimer cette photo ?",
          photoProcessingError: "Erreur lors du traitement de la photo",
          bgCompositionError: "Erreur lors de la composition du fond",
          bgApplyError: "Impossible d'appliquer ce fond",
          photoUpdated: "Photo mise à jour",
          describeVehiclePlaceholder: "Décrivez votre véhicule (état, historique, options...)",
          generateWithAi: "Générer avec l'IA",
          descriptionGenerated: "Description générée !",
          descriptionGenerationError: "Erreur lors de la génération",
          listingPublishedSuccess: "Annonce publiée avec succès !",
          listingPublishError: "Erreur lors de la publication",
          publishListingBtn: "Publier l'annonce",
          publishingInProgress: "Publication en cours…",
          noListingToUpdate: "Aucune annonce à mettre à jour.",
          listingUpdatedSuccess: "Annonce mise à jour",
          errorPrefix: "Erreur:",
          saveChangesBtn: "Enregistrer les modifications",
          bgRemovedChooseOption: "Arrière-plan supprimé — Choisissez une option",
          withoutBackground: "Sans fond",
          withBackground: "Avec fond",
          chooseBackground: "Choisir un arrière-plan :",
          customColor: "Couleur personnalisée",
          customPhoto: "Photo personnalisée",
          keepWithoutBackground: "Garder sans fond",
          useThisBackground: "Utiliser ce fond",
          mainPhotoSet: "Photo principale définie",

          registerHeroBadgePro: "Compte Professionnel",
          registerHeroBadgePart: "Compte Particulier",
          registerHeroTitlePro: "Gérez votre activité automobile",
          registerHeroTitlePart: "Vendez votre voiture en quelques clics",
          registerHeroSubPro: "Accédez à des outils dédiés aux concessionnaires et garages : gestion de flotte, messagerie, tableau de bord.",
          registerHeroSubPart: "Publiez votre annonce gratuitement et touchez des milliers d'acheteurs potentiels au Maroc.",
          heroPro1: "Tableau de bord professionnel",
          heroPro2: "Gestion multi-annonces",
          heroPro3: "Page vitrine de votre concession",
          heroPro4: "Statistiques de performance",
          heroPart1: "Annonce gratuite et illimitée",
          heroPart2: "Messagerie directe avec acheteurs",
          heroPart3: "Gestion facile de vos annonces",
          heroPart4: "Mise en ligne en moins de 5 min",

          /* ── AddCars / Sell page ── */
          quickSale: "Vente rapide",
          sellCarHeroTitleLine1: "Vendez votre",
          sellCarHeroTitleLine2: "voiture facilement",
          sellCarHeroSub: "Des millions d'acheteurs potentiels vous attendent sur Carix.",
          benefitFree: "Publication 100% gratuite",
          benefitFast: "Mise en ligne en 5 minutes",
          benefitVerifiedBuyers: "Acheteurs vérifiés et sérieux",
          benefitSupport: "Support disponible 7j/7",
          statActiveListings: "Annonces actives",
          statBuyersPerMonth: "Acheteurs / mois",
          statFree: "Gratuit",
          basicInfo: "Informations de base",
          stepOneOfTwo: "Étape 1 sur 2 — Votre véhicule",
          selectBrand: "Sélectionner une marque",
          selectModel: "Sélectionner un modèle",
          selectBrandFirst: "Choisissez d'abord une marque",
          continueBtn: "Continuer",

          /* ── Video generator ── */
          videoGenTitle: "Générer une vidéo de présentation",
          backgroundMusic: "Musique de fond",
          noMusicTracksPrefix: "Aucun morceau disponible — placez des .mp3 dans",
          durationPerPhoto: "Durée par photo",
          generatingInProgress: "En cours...",
          generateVideoBtn: "Générer la vidéo",
          downloadLocally: "Télécharger en local",
          addedToListingBtn: "Ajoutée à l'annonce",
          addingInProgress: "Ajout en cours...",
          addToListingBtn: "Ajouter à l'annonce",
          preparingPhotos: "Préparation des photos...",
          generatingVideoProgress: "Génération de la vidéo en cours (peut prendre 20-30s)...",
          videoGeneratedSuccess: "Vidéo générée avec succès !",
          unknownError: "Erreur inconnue",
          videoAddedSuccess: "Vidéo ajoutée à l'annonce !",
          videoAddError: "Erreur lors de l'ajout de la vidéo à l'annonce",

          /* ── Credit calculator ── */
          financingSimulator: "Simulateur de financement",
          initialDownPayment: "Apport initial",
          duration: "Durée",
          monthsLabel: "mois",
          annualRate: "Taux annuel",
          estimatedMonthlyPayment: "Mensualité estimée",
          perMonth: "/mois",
          financedAmount: "Montant financé",
          totalInterest: "Total intérêts",
          totalCreditCost: "Coût total crédit",
          simulationDisclaimer: "Simulation indicative — contactez votre banque pour une offre personnalisée.",

          /* ── AI price estimation ── */
          aiPriceEstimation: "Estimation IA du prix",
          aiPriceDesc: "Notre IA analyse les annonces similaires pour évaluer si ce prix est compétitif.",
          analyzePrice: "Analyser le prix",
          analyzingInProgress: "Analyse en cours...",
          fairPrice: "Prix juste",
          abovePriceMarket: "{{pct}}% au-dessus du marché",
          belowPriceMarket: "{{pct}}% en dessous du marché",
          listingPrice: "Prix annonce",
          estimatedMarketPrice: "Prix estimé marché",
          priceRange: "Fourchette",
          retryAnalysis: "Relancer l'analyse",
          estimationError: "Erreur {{status}}: {{detail}}",

          /* ── Price history ── */
          priceHistoryTitle: "Historique de prix",
          stable: "Stable",
          today: "Aujourd'hui",

          /* ── Chat widget ── */
          contactViaChat: "Contacter via chat",
          chatWith: "Chat avec {{name}}",
          online: "En ligne",
          connecting: "Connexion...",
          startConversation: "Envoyez un message pour démarrer la conversation.",
          yourMessagePlaceholder: "Votre message...",

          /* ── Compare ── */
          carsCountLabel: "{{count}}/3 voitures",
          compareBtn: "Comparer",
          compareTitle: "Comparateur",
          clearAll: "Tout effacer",
          loadingCarDetails: "Chargement des détails...",
          noCarsToCompare: "Aucune voiture à comparer",
          addUpTo3CarsDesc: "Ajoutez jusqu'à 3 voitures depuis la liste ou les fiches détail.",
          browseListingsBtn: "Parcourir les annonces",
          seeListingFull: "Voir l'annonce",
          getAiAdvice: "Obtenir le conseil IA — Quel est le meilleur choix ?",
          aiAdviceTitle: "Conseil IA — AutoMarket",
          bestChoice: "Meilleur choix",
          quality: "Qualité",
          overallScore: "Score global",
          recommendationLabel: "Notre recommandation",
          aiServiceUnavailable: "Service IA indisponible.",

          /* ── Search alert ── */
          alertTooltip: "Créer une alerte pour ces filtres",
          alertOnFilters: "Alerter sur ces filtres",
          createAlertBtn: "Créer une alerte",
          alertDesc: "Recevez un email dès qu'une annonce correspond à vos critères actuels",
          emailOptionalPlaceholder: "Email (optionnel, utilise celui du compte)",
          creatingInProgress: "Création...",
          createAlertSubmit: "Créer l'alerte",
          alertCreatedSuccess: "Alerte créée ! Vous serez notifié par email.",
          alertCreateError: "Erreur lors de la création de l'alerte",

          /* ── Dashboard / PageLoader ── */
          dashboardProTitle: "Dashboard Professionnel",
          marketplaceTagline: "Marketplace Automobile",

          /* ── Abonnements ── */
          mySubscription: "Mon abonnement",
          comingSoon: "Bientôt disponible",
          freeForNow: "L'application est actuellement gratuite pour tous les comptes.",
          subscriptionPlans: "Plans d'abonnement",
          planStarter: "Starter",
          planPremium: "Premium",
          planElite: "Elite",
          billingMonthly: "Mensuel",
          billingYearly: "Annuel",
          subscribeNow: "S'abonner",
          renewSubscription: "Renouveler",
          currentPlan: "Plan actuel",
          noActivePlan: "Aucun abonnement actif",
          daysRemaining: "Jours restants",
          paymentSuccess: "Paiement réussi",
          paymentFailed: "Le paiement a échoué",
          redirectingToPayment: "Redirection vers le paiement…",
          invoiceHistory: "Historique des factures",
          cancelSubscription: "Annuler le renouvellement",
          maxListingsReached: "Limite d'annonces atteinte pour votre abonnement",

          /* ── Footer ── */
          footerTagline: "Des milliers de voitures vous attendent",
          footerBrowseCta: "Parcourir les annonces",
          footerDesc: "La plateforme numéro 1 au Maroc pour acheter et vendre des voitures d'occasion. Des milliers d'annonces vérifiées, des vendeurs de confiance.",
          navigation: "Navigation",
          categoriesTitle: "Catégories",
          contactTitle: "Contact",
          mySpace: "Mon espace",
          favoritesNav: "Favoris",
          companyLocation: "Kénitra, Maroc",
          footerCopyright: "© {{year}} Carix. Tous droits réservés.",
          termsOfService: "Conditions d'utilisation",
          privacyPolicy: "Politique de confidentialité",
          cookies: "Cookies",

          footerCategories: {
            citadines: "Citadines",
            berlines: "Berlines",
            suv4x4: "SUV & 4x4",
            coupes: "Coupés",
            monospaces: "Monospaces",
            utilitaires: "Utilitaires",
            cabriolets: "Cabriolets",
            electriques: "Électriques",
          },

          /* ── CarDetails page misc ── */
          confirmDeleteContent: "Cette action est irréversible.",
          errorOccurred: "Une erreur est survenue",
          sessionExpired: "Votre session a expiré, veuillez vous reconnecter",
          listingDeactivated: "Annonce désactivée",
          listingActivated: "Annonce activée",
          markAsSold: "Marquer comme vendu",
          markAsAvailable: "Remettre en vente",
          confirmMarkSold: "Marquer cette annonce comme vendue ?",
          confirmMarkAvailable: "Remettre cette annonce en vente ?",
          listingMarkedSold: "Annonce marquée comme vendue",
          listingMarkedAvailable: "Annonce remise en vente",
          soldBadge: "Vendu",
          history: "Historique",
          reviews: "avis",
          promoRemoved: "Promotion retirée",
          promoAdded: "Annonce mise en promotion",
          removePromo: "Retirer promo",
          addPromo: "Mettre en promo",
          verifiedSeller: "Vendeur vérifié",
          verifiedBadge: "Vérifié",
          proSeller: "Vendeur professionnel",
          proBadge: "Pro",
          seeSellerProfile: "Voir le profil",
          callBtn: "Appeler",
          messageSentSuccess: "Message envoyé ✅",
          messageSentError: "Erreur envoi ❌",
          newCondition: "Neuf",
          usedCondition: "Occasion",
          origin: "Origine",
          originCleared: "Dédouanée",
          originWW: "WW au Maroc",
          originNotCleared: "Pas encore dédouanée",
          originImportedNew: "Importée neuve",
          loadingListing: "Chargement de l'annonce...",
          promotionBadge: "Promotion",
          noEquipmentAvailable: "Aucun équipement disponible",
          boostListing: "Booster l'annonce",
          confirmAndPay: "Confirmer et payer",
          boostConfirmMessage: "Mettez votre annonce en avant pendant {{days}} jours pour {{price}} MAD.",
          boostedUntil: "Boosté jusqu'au {{date}}",

          /* ── Dictionaries for database-driven content ── */
          colorNames: {
            Blanc: "Blanc", Noir: "Noir", Gris: "Gris", Argent: "Argent",
            Rouge: "Rouge", Bleu: "Bleu", "Bleu ciel": "Bleu ciel", Vert: "Vert",
            Beige: "Beige", Marron: "Marron", Orange: "Orange", Jaune: "Jaune",
            Violet: "Violet", Rose: "Rose",
          },
          paintTypes: {
            "Métallisée": "Métallisée", "Nacrée": "Nacrée", "Unie": "Unie", "Mat": "Mat",
          },
          interiorMaterials: {
            "Cuir": "Cuir", "Tissu": "Tissu", "Alcantara": "Alcantara", "Mixte": "Mixte",
          },
          equipmentCategories: {
            "Confort": "Confort", "Sécurité": "Sécurité", "Multimédia": "Multimédia",
            "Extérieur": "Extérieur", "Technologie": "Technologie", "Autres": "Autres",
          },
          equipmentNames: {
            "Climatisation": "Climatisation",
            "Climatisation automatique": "Climatisation automatique",
            "Sièges électriques": "Sièges électriques",
            "Sièges chauffants": "Sièges chauffants",
            "Démarrage sans clé": "Démarrage sans clé",
            "Vitres électriques": "Vitres électriques",
            "Vitres teintées": "Vitres teintées",
            "Apple CarPlay": "Apple CarPlay",
            "Android Auto": "Android Auto",
            "Régulateur de vitesse": "Régulateur de vitesse",
            "GPS / Navigation": "GPS / Navigation",
            "Caméra de recul": "Caméra de recul",
            "Radar de recul": "Radar de recul",
            "Toit ouvrant": "Toit ouvrant",
            "Jantes aluminium": "Jantes aluminium",
            "ABS": "ABS",
            "ESP": "ESP",
            "Airbags": "Airbags",
            "Bluetooth": "Bluetooth",
            "Attelage remorque": "Attelage remorque",
            "Verrouillage centralisé": "Verrouillage centralisé",
            "Aide au stationnement": "Aide au stationnement",
            "Capteurs de pluie": "Capteurs de pluie",
            "Phares LED": "Phares LED",
            "Phares Xénon": "Phares Xénon",
            "Volant multifonction": "Volant multifonction",
            "Ordinateur de bord": "Ordinateur de bord",
            "Alarme": "Alarme",
            "Accès sans clé": "Accès sans clé",
            "Rétroviseurs électriques": "Rétroviseurs électriques",
            "Toit panoramique": "Toit panoramique",
            "Volant chauffant": "Volant chauffant",
            "Attelage": "Attelage",
            "Barre de toit": "Barre de toit",
            "Jantes alliage": "Jantes alliage",
            "Phares adaptatifs": "Phares adaptatifs",
            "Phares Full LED": "Phares Full LED",
            "Rétroviseurs rabattables électriquement": "Rétroviseurs rabattables électriquement",
            "Spoiler": "Spoiler",
            "Caméra 360°": "Caméra 360°",
            "Chargeur sans fil": "Chargeur sans fil",
            "Connexion Wi-Fi": "Connexion Wi-Fi",
            "Écran tactile": "Écran tactile",
            "Prise USB": "Prise USB",
            "Système audio premium": "Système audio premium",
            "Airbag conducteur": "Airbag conducteur",
            "Airbag passager": "Airbag passager",
            "Airbags latéraux": "Airbags latéraux",
            "Alerte franchissement de ligne": "Alerte franchissement de ligne",
            "Assistance freinage d'urgence": "Assistance freinage d'urgence",
            "Capteurs de stationnement arrière": "Capteurs de stationnement arrière",
            "Capteurs de stationnement avant": "Capteurs de stationnement avant",
            "Limiteur de vitesse": "Limiteur de vitesse",
          },

          /* ── Admin dashboard ── */
          adminOverviewNav: "Vue d'ensemble",
          adminVerificationsNav: "Vérifications",
          adminUsersNav: "Utilisateurs",
          adminCarsNav: "Annonces",
          adminPanel: "Administration",
          totalUsers: "Total utilisateurs",
          totalParticuliers: "Particuliers",
          totalProfessionnels: "Professionnels",
          pendingVerifications: "Vérifications en attente",
          totalMessagesStat: "Messages totaux",
          noVerificationRequests: "Aucune demande de vérification",
          requestedOn: "Demandée le",
          approve: "Approuver",
          reject: "Refuser",
          rejectReasonPrompt: "Motif du refus (optionnel)",
          verificationApproved: "Demande approuvée",
          verificationRejected: "Demande refusée",
          searchUser: "Rechercher un utilisateur...",
          allRoles: "Tous les rôles",
          userColumn: "Utilisateur",
          roleColumn: "Rôle",
          verifiedColumn: "Vérifié",
          bannedColumn: "Banni",
          listingsColumn: "Annonces",
          ban: "Bannir",
          unban: "Débannir",
          confirmBan: "Bannir cet utilisateur ?",
          confirmBanContent: "Il ne pourra plus se connecter tant qu'il n'est pas débanni.",
          confirmUnban: "Débannir cet utilisateur ?",
          userBanned: "Utilisateur banni",
          userUnbanned: "Utilisateur débanni",
          roleUpdated: "Rôle mis à jour",
          resetPassword: "Réinitialiser mot de passe",
          resetPasswordFor: "Réinitialiser le mot de passe de {{name}}",
          newPassword: "Nouveau mot de passe",
          passwordResetSuccess: "Mot de passe réinitialisé avec succès",
          passwordResetError: "Erreur lors de la réinitialisation du mot de passe",
          changeEmail: "Changer l'email",
          changeEmailFor: "Changer l'email de {{name}}",
          newEmail: "Nouvel email",
          emailChangedSuccess: "Email mis à jour avec succès",
          emailChangedError: "Erreur lors du changement d'email",
          allCarsAdmin: "Toutes les annonces",
          unauthorizedTitle: "Accès refusé",
          unauthorizedDesc: "Vous n'avez pas les droits nécessaires pour accéder à cette page.",
          backToHome: "Retour à l'accueil",

          fuelTypes: {
            Essence: "Essence",
            Diesel: "Diesel",
            Hybride: "Hybride",
            Electrique: "Électrique"
          },

          transmissions: {
            Manuelle: "Manuelle",
            Automatique: "Automatique"
          },

          sellerTypes: {
            Particulier: "Particulier",
            Professionnel: "Professionnel",
            Admin: "Admin"
          },

          bodyTypes: {
            Berline: "Berline",
            SUV: "SUV",
            "Coupé": "Coupé",
            Break: "Break",
            Cabriolet: "Cabriolet",
            Monospace: "Monospace",
            "Pick-up": "Pick-up",
            Citadine: "Citadine"
}
        }
      },

      en: {
        translation: {
          home: "Home",
          buyCar: "Buy a car",
          sellCar: "Sell",
          featuredCars: "Featured Cars",
          cars: "Cars",
          login: "Login",
          loginOut: "LogOut",
          register: "Register",
          offers: "offers",
          sort: "Sort",
          contactSeller: "Contact seller",
          mileage: "Mileage",
          transmission: "Transmission",
          year: "Year",
          fuelType: "Fuel type",
          power: "Power",
          seller: "Seller",
          searchByBrand: "Search by brand",
          price: "Price",
          publishedOn: "Published on",
          status: "Status",
          phoneNumber: "Phone number",
          loading: "Loading...",
          noCarsFound: "No cars found",
          noResults: "No results",
          allBrands: "all brands",
          allModels: "all models",
          allGenerations: "all generations",
          standardResults: "Standard results",
          priceAscending: "Price ascending",
          priceDescending: "Price descending",
          mostRecent: "Most recent",
          lowMileage: "Low mileage",
          veryGoodPrice: "Very good price",
          diesel: "Diesel",
          for: "for",
          priceNotSpecified: "Price not specified",
          messageBtn: "Message",
          postedToday: "Today",
          postedYesterday: "Yesterday",
          postedDaysAgo: "{{count}} days ago",
          postedOneWeekAgo: "1 week ago",
          postedWeeksAgo: "{{count}} weeks ago",
          postedOneMonthAgo: "1 month ago",
          postedMonthsAgo: "{{count}} months ago",
          share: "Share",
          print: "Print",
          brand: "Brand",
          model: "Model",
          generation: "Generation",
          popularBrands: "Popular brands",
          sendResetLink: "Send reset link",
          resetPasswordSuccess:
            "If this email exists, you will receive a reset link.",
          forgotPasswordError:
            "Failed to send reset link",
          maxPrice: "Max price (MAD)",
          selectMaxPrice: "Select maximum price",
          firstRegistration: "First registration",
          results: "results",
          resultsLoading: "results...",
          basicData: "Basic Data",
          vehicleHistory: "Vehicle History",
          technicalSpecs: "Technical Specifications",
          colorsInterior: "Colors & Interior",
          bodyType: "Body type",
          motoType: "Motorcycle type",
          utilitaireBodyType: "Body style",
          payloadCapacity: "Payload capacity",
          cargoVolume: "Cargo volume",
          vehicleType: "Vehicle type",
          condition: "Condition",
          doors: "Number of doors",
          warranty: "Warranty",
          previousOwners: "Previous owners",
          smoker: "Smoker",
          engineCapacity: "Engine capacity",
          gears: "Gears",
          exteriorColor: "Exterior color",
          paintType: "Paint type",
          interiorColor: "Interior color",
          interior: "Interior",
          country: "Country",
          seats: "Seats",
          carCharacteristics: "Car characteristics",
          equipment: "Equipment",
          images: "Images",
          yourName: "Your name",
          yourEmail: "Your email",
          yourPhone: "Your phone",
          promoUsedCars: "PROMOTIONAL USED CARS",
          listingNumber: "Listing number",
          acceptData: "I accept the processing of my data",
          defaultContactMessage: `Hello,

          I am interested in your vehicle. Is it still available?

          Best regards,`,
          km: "km",
          hp: "hp",
          browseBy: "Browse by",
          topBrands: "Popular brands",
          heroTitle: "Find your ideal car",
          heroSub: "Thousands of verified listings in Morocco",
          vehicleTypes: {
            cars: "Cars",
            caravans: "Caravans",
            vans: "Vans",
            trucks: "Trucks",
            trailers: "Trailers",
            motorcycles: "Motorcycles",
            comingSoon: "Coming soon",
          },
          otherBrands: "Other brands",
          searchBtn: "Search",
          seeResults: "See {{count}} listing",
          seeResultsPlural: "See {{count}} listings",
          languageChanged: "Language changed",
          searchByBodyType: "Search by body type",
          citadine: "City car",
          suv: "SUV",
          pickup: "Pick-up",
          utility: "Utility vehicle",
          convertible: "Convertible",
          minivan: "Minivan",
          sedan: "Sedan",
          stationWagon: "Station wagon",
          coupe: "Coupe",
          loginWith: "Log in with",
          emailAddress: "Email address",
          password: "Password",
          forgotPassword: "Forgot password?",
          dontHaveAccount: "Don't have an account?",
          signUp: "Sign up",
          signUpWithGoogle: "Sign up with Google",
          signUpWithFacebook: "Sign up with Facebook",
          completeYourProProfile: "Account created! Complete your professional profile so buyers can find you.",
          facebookLoginCancelled: "Facebook login cancelled.",
          facebookLoginFailed: "Facebook login failed. If the app is still in development mode, check that your account was added as a tester.",
          missingToken: "Missing token",
          or: "or",
          currency: "MAD",
          loginFailed: "Invalid email or password",
          createAccount: "Create your account",
          fullName: "Full name",
          alreadyHaveAccount: "Already have an account?",
          passwordNotMatch: "Passwords do not match",
          registerSuccess: "Account created successfully",
          registerError: "Registration failed",
          emailAlreadyExists: "An account already exists with this email.",
          goToLogin: "Log in",
          passwordRequirements: "At least 6 characters.",
          passwordTooWeak: "Invalid password: ",
          companyName: "Company name",
          profileTitle: "My Profile",
          addPhoto: "Add photo",
          changePhoto: "Change photo",
          coverPhoto: "Cover photo",
          addCoverPhoto: "Add cover photo",
          changeCoverPhoto: "Change cover photo",
          save: "Save",
          requiredFields: "Please fill in all required fields, including cover photo.",
          profileUpdated: "Profile updated",
          updateError: "Error updating profile",
          username: "Username",
          city: "City",
          particulier: "Particulier",
          professionnel: "Company",
          resetPassword: "Reset Password",
          newPassword: "New Password",
          confirmPassword: "Confirm Password",
          passwordResetSuccess:
            "Password reset successful",
          resetPasswordFailed:
            "Reset password failed",
          backToLogin: "Back to login",
          yes: "Yes",
          no: "No",

          /* ── Dashboard / MyCars ── */
          resetFilters: "Reset filters",
          myListings: "My listings",
          newListing: "New listing",
          search: "Search...",
          allTypes: "All types",
          allStatus: "All",
          activeStatus: "Active",
          inactiveStatus: "Inactive",
          listingDeleted: "Listing deleted",
          confirmDelete: "Are you sure you want to delete this listing?",
          totalListings: "Total listings",
          activeListingsCount: "Active listings",
          totalViews: "Total views",
          messages: "Messages",
          carColumn: "Car",
          views: "Views",
          actions: "Actions",
          seeListing: "See listing",
          edit: "Edit",
          deactivate: "Deactivate",
          activate: "Activate",
          delete: "Delete",
          activeLabel: "ACTIVE",
          inactiveLabel: "INACTIVE",
          notifications: "Notifications",
          noNotifications: "No notifications",
          dashboard: "Dashboard",
          addListing: "Add listing",
          statisticsNav: "Statistics",
          settings: "Settings",
          settingsComingSoon: "Settings will be available soon...",
          statisticsViews: "Views statistics",
          myFavorites: "My favorites",
          chat: "Chat",
          myAccount: "My account",
          headerMyListings: "My listings",
          headerFavorites: "My favorites",
          headerProfile: "Profile",
          previous: "Previous",
          next: "Next",
          professionalSellers: "Professional Sellers",
          seeProfile: "See profile",
          carsListed: "listings",
          description: "Description",
          descriptionPlaceholder: "Describe your activity, services...",
          chooseLocation: "Choose your location",
          myLocation: "My location",
          locating: "Locating...",
          searchAddress: "Search an address...",
          confirm: "Confirm",
          cancel: "Cancel",
          clickAddPhotos: "Click to add photos",
          editBackground: "Edit background",
          noFavorites: "No favorites yet",
          removeFavorite: "Remove from favorites",
          addToFavorites: "Add to favorites",
          removeFromFavorites: "Remove from favorites",
          noMessages: "No messages yet",
          selectConversation: "Select a conversation",
          typeMessage: "Type a message...",
          noDataYet: "No data yet",

          /* ── PromoCars ── */
          promoLabel: "Featured",
          promoCarsTitle: "Boosted Listings",
          seeAllListings: "See all listings",
          promoCardCta: "See listing",
          latestListingsLabel: "Freshly published",
          latestListingsTitle: "Latest Listings",
          statsListings: "Active listings",
          statsSellers: "Registered sellers",
          statsCities: "Cities covered",

          /* ── NewCars / Why section ── */
          ourAdvantages: "Our Advantages",
          whyChooseUs: "Why choose Carix?",
          whyChooseUsSub: "The most complete platform to buy and sell your car in Morocco.",
          feature1Title: "Smart Search",
          feature1Desc: "Filter by brand, model, body type, mileage, price and more. Find exactly what you're looking for in a few clicks.",
          feature2Title: "Verified Listings",
          feature2Desc: "Every seller is verified and every listing is reviewed. Buy with confidence thanks to our validation system.",
          feature3Title: "Direct Contact",
          feature3Desc: "Communicate directly with the seller via our integrated messaging. No middleman, no hidden commission.",
          feature4Title: "Quick Listing",
          feature4Desc: "Post your listing in under 5 minutes with our guided form. Your photos are automatically optimized.",

          /* ── Reviews / Testimonials ── */
          testimonialsLabel: "Testimonials",
          testimonialsTitle: "What our users say",
          member: "Member",
          testimonialsSub: "A platform designed to make buying and selling cars simple and reliable.",
          statListingsPublished: "Listings published",
          statBuyersSatisfied: "Satisfied buyers",
          statAverageRating: "Average rating",
          statSatisfactionRate: "Satisfaction rate",

          /* ── Misc ── */
          verifiedPartners: "Verified Partners",
          promoToggleTitle: "Special Offer / Promotion",
          promoToggleDesc: "Your listing will be featured in the \"Special Offers\" section with a promo badge.",
          recentlyViewed: "Recently viewed",

          /* ── Login / Register page ── */
          loginSubtitle: "Access your Carix account",
          loginHeroBadge: "Morocco's #1 Platform",
          loginHeroTitle: "Buy and sell your car easily",
          loginHeroSub: "Join thousands of individuals and professionals who trust Carix.",
          loginHeroFeature1: "50,000+ vehicles available",
          loginHeroFeature2: "Secure integrated messaging",
          loginHeroFeature3: "Verified and reliable listings",
          heroStatListings: "Listings",
          heroStatBuyers: "Buyers",
          heroStatSatisfaction: "Satisfaction",
          heroLaunchMessage: "Freshly launched platform — be among the first to join Carix and post your listing.",

          registerSubtitle: "Choose your account type",
          particulierDesc: "Private buyer or seller",
          professionnelDesc: "Dealership or garage",
          sectionInfos: "Information",
          sectionPresentation: "Presentation",
          sectionSecurity: "Security",
          sectionLocation: "Location",
          sectionPhotos: "Photos",
          profilePhotoLabel: "Profile photo",
          establishmentAddress: "Your establishment address",

          /* ── ProfilePage ── */
          addressRequired: "The Address field is required.",
          companyNameRequiredForSwitch: "Your company name (the \"Full name\" field above) is required.",
          switchToProSuccess: "Your account is now a Professional account!",
          switchToProError: "Error while changing your account",
          myProfileFallback: "My profile",
          personalInfoTitle: "Personal information",
          usernameLabel: "Username",
          addressLabel: "Address *",
          fieldRequired: "This field is required",
          addressPlaceholder: "Enter your address...",
          pointLocation: "Pin location",
          coordinatesLabel: "Coordinates:",
          switchToProTitle: "Switch to a Professional account",
          switchToProDesc: "Sell as a professional: company page, public description and access to Pro tools. The \"Full name\" field above will be used as your company name, and your current location / cover photo will be kept. Add a description of your activity below.",
          switchToProFinalNotice: "This change is permanent.",
          activityDescriptionLabel: "Description of your activity",
          switchingInProgress: "Switching in progress...",
          becomeProfessionalSeller: "Become a Professional seller",
          accountVerificationTitle: "Account verification",
          verifiedAccountBadge: "Verified account",
          verificationPendingBadge: "Request under review",
          verificationPendingDesc: "Your verification request has been received. Our team is reviewing it and will get back to you within 48 business hours — no further action is required from you.",
          verificationRejectedNotice: "Your previous request was not approved.",
          rejectionReasonLabel: "Reason:",
          verificationRejectedHint: "You can correct your profile information above and submit a new request.",
          verificationBenefitsDesc: "A verified account displays a trust badge visible to other users, boosts your credibility and increases the number of contacts you receive. For extra safety, we recommend verifying your account before publishing your listings.",
          verificationRequestSentSuccess: "Request sent! Our team will contact you.",
          verificationRequestError: "Error while sending the request",
          resubmitVerificationRequest: "Submit a new request",
          requestVerificationBtn: "Request verification",

          /* ── SellerProfile ── */
          ratingsCount: "Ratings",
          previousOwnersLabel: "Previous owner(s)",
          seeLess: "See less",
          seeMore: "See more",
          searchFor: "Search for",
          carTypeLabel: "Car",
          fromLabel: "From",
          toLabel: "To",
          yourMessage: "Your message",
          sendLabel: "Send",
          memberSince: "Member since",
          close: "Close",

          /* ── Settings ── */
          accountDeleteError: "Error while deleting your account.",
          emailNotifLabel: "Email notifications",
          emailNotifDesc: "Receive new contact requests by email",
          messageNotifLabel: "Message notifications",
          messageNotifDesc: "Get alerted when you receive new messages",
          promoNotifLabel: "Offers & promotions",
          promoNotifDesc: "Receive news and special offers from the platform",
          securitySection: "Security",
          changePasswordLabel: "Change password",
          changePasswordDesc: "Change your password regularly to keep your account secure",
          modifyArrowLabel: "Edit →",
          editProfileLabel: "Edit profile",
          editProfileDesc: "Update your personal information and profile photo",
          languageSection: "Language",
          dangerZoneTitle: "Danger zone",
          deleteAccountLabel: "Delete my account",
          deleteAccountDesc: "This action is irreversible. All your listings and data will be deleted.",
          deleteAccountConfirmText: "Are you sure? This will permanently delete your account and all your listings.",
          deletingInProgress: "Deleting…",
          confirmAccountDeletion: "Confirm deletion",

          /* ── Favorites ── */
          removeFavoriteTitle: "Remove from favorites?",
          removeFavoriteContent: "This car will be removed from your favorites list.",
          removeLabel: "Remove",
          listingSingular: "listing",
          listingPlural: "listings",
          noFavoritesDesc: "Add cars to your favorites to find them here.",
          browseListings: "Browse listings",

          /* ── Header ── */
          userFallback: "User",
          emailNotConfirmedWarning: "Your email address is not confirmed yet. Check your inbox to unlock all features.",
          emailResent: "Email resent",
          sendingInProgress: "Sending...",
          resendConfirmationEmail: "Resend confirmation email",

          /* ── MultiStepCarForm ── */
          mainPhoto: "Main photo",
          mainLabel: "Main",
          setAsMainPhoto: "Set as main photo",
          removeBackground: "Remove background",
          confirmDeletePhoto: "Delete this photo?",
          photoProcessingError: "Error while processing the photo",
          bgCompositionError: "Error while compositing the background",
          bgApplyError: "Could not apply this background",
          photoUpdated: "Photo updated",
          describeVehiclePlaceholder: "Describe your vehicle (condition, history, options...)",
          generateWithAi: "Generate with AI",
          descriptionGenerated: "Description generated!",
          descriptionGenerationError: "Error while generating",
          listingPublishedSuccess: "Listing published successfully!",
          listingPublishError: "Error while publishing the listing",
          publishListingBtn: "Publish listing",
          publishingInProgress: "Publishing…",
          noListingToUpdate: "No listing to update.",
          listingUpdatedSuccess: "Listing updated",
          errorPrefix: "Error:",
          saveChangesBtn: "Save changes",
          bgRemovedChooseOption: "Background removed — Choose an option",
          withoutBackground: "Without background",
          withBackground: "With background",
          chooseBackground: "Choose a background:",
          customColor: "Custom color",
          customPhoto: "Custom photo",
          keepWithoutBackground: "Keep without background",
          useThisBackground: "Use this background",
          mainPhotoSet: "Main photo set",

          registerHeroBadgePro: "Professional Account",
          registerHeroBadgePart: "Personal Account",
          registerHeroTitlePro: "Manage your automotive business",
          registerHeroTitlePart: "Sell your car in a few clicks",
          registerHeroSubPro: "Access tools dedicated to dealerships and garages: fleet management, messaging, dashboard.",
          registerHeroSubPart: "Post your listing for free and reach thousands of potential buyers in Morocco.",
          heroPro1: "Professional dashboard",
          heroPro2: "Multi-listing management",
          heroPro3: "Your dealership showcase page",
          heroPro4: "Performance statistics",
          heroPart1: "Free and unlimited listing",
          heroPart2: "Direct messaging with buyers",
          heroPart3: "Easy listing management",
          heroPart4: "Online in under 5 minutes",

          /* ── AddCars / Sell page ── */
          quickSale: "Quick sale",
          sellCarHeroTitleLine1: "Sell your",
          sellCarHeroTitleLine2: "car easily",
          sellCarHeroSub: "Millions of potential buyers are waiting for you on Carix.",
          benefitFree: "100% free listing",
          benefitFast: "Live in 5 minutes",
          benefitVerifiedBuyers: "Verified and serious buyers",
          benefitSupport: "Support available 7 days a week",
          statActiveListings: "Active listings",
          statBuyersPerMonth: "Buyers / month",
          statFree: "Free",
          basicInfo: "Basic information",
          stepOneOfTwo: "Step 1 of 2 — Your vehicle",
          selectBrand: "Select a brand",
          selectModel: "Select a model",
          selectBrandFirst: "Choose a brand first",
          continueBtn: "Continue",

          /* ── Video generator ── */
          videoGenTitle: "Generate a presentation video",
          backgroundMusic: "Background music",
          noMusicTracksPrefix: "No tracks available — place .mp3 files in",
          durationPerPhoto: "Duration per photo",
          generatingInProgress: "In progress...",
          generateVideoBtn: "Generate video",
          downloadLocally: "Download locally",
          addedToListingBtn: "Added to listing",
          addingInProgress: "Adding...",
          addToListingBtn: "Add to listing",
          preparingPhotos: "Preparing photos...",
          generatingVideoProgress: "Generating video (can take 20-30s)...",
          videoGeneratedSuccess: "Video generated successfully!",
          unknownError: "Unknown error",
          videoAddedSuccess: "Video added to listing!",
          videoAddError: "Error adding video to listing",

          /* ── Credit calculator ── */
          financingSimulator: "Financing simulator",
          initialDownPayment: "Down payment",
          duration: "Duration",
          monthsLabel: "months",
          annualRate: "Annual rate",
          estimatedMonthlyPayment: "Estimated monthly payment",
          perMonth: "/month",
          financedAmount: "Financed amount",
          totalInterest: "Total interest",
          totalCreditCost: "Total credit cost",
          simulationDisclaimer: "Indicative simulation — contact your bank for a personalized offer.",

          /* ── AI price estimation ── */
          aiPriceEstimation: "AI price estimation",
          aiPriceDesc: "Our AI analyzes similar listings to assess whether this price is competitive.",
          analyzePrice: "Analyze price",
          analyzingInProgress: "Analyzing...",
          fairPrice: "Fair price",
          abovePriceMarket: "{{pct}}% above market",
          belowPriceMarket: "{{pct}}% below market",
          listingPrice: "Listing price",
          estimatedMarketPrice: "Estimated market price",
          priceRange: "Range",
          retryAnalysis: "Retry analysis",
          estimationError: "Error {{status}}: {{detail}}",

          /* ── Price history ── */
          priceHistoryTitle: "Price history",
          stable: "Stable",
          today: "Today",

          /* ── Chat widget ── */
          contactViaChat: "Contact via chat",
          chatWith: "Chat with {{name}}",
          online: "Online",
          connecting: "Connecting...",
          startConversation: "Send a message to start the conversation.",
          yourMessagePlaceholder: "Your message...",

          /* ── Compare ── */
          carsCountLabel: "{{count}}/3 cars",
          compareBtn: "Compare",
          compareTitle: "Comparison",
          clearAll: "Clear all",
          loadingCarDetails: "Loading details...",
          noCarsToCompare: "No cars to compare",
          addUpTo3CarsDesc: "Add up to 3 cars from the list or the detail pages.",
          browseListingsBtn: "Browse listings",
          seeListingFull: "See listing",
          getAiAdvice: "Get AI advice — Which is the best choice?",
          aiAdviceTitle: "AI Advice — AutoMarket",
          bestChoice: "Best choice",
          quality: "Quality",
          overallScore: "Overall score",
          recommendationLabel: "Our recommendation",
          aiServiceUnavailable: "AI service unavailable.",

          /* ── Search alert ── */
          alertTooltip: "Create an alert for these filters",
          alertOnFilters: "Alert on these filters",
          createAlertBtn: "Create an alert",
          alertDesc: "Receive an email as soon as a listing matches your current criteria",
          emailOptionalPlaceholder: "Email (optional, uses the account's email)",
          creatingInProgress: "Creating...",
          createAlertSubmit: "Create alert",
          alertCreatedSuccess: "Alert created! You will be notified by email.",
          alertCreateError: "Error creating the alert",

          /* ── Dashboard / PageLoader ── */
          dashboardProTitle: "Professional Dashboard",
          marketplaceTagline: "Automotive Marketplace",

          /* ── Subscriptions ── */
          mySubscription: "My subscription",
          comingSoon: "Coming soon",
          freeForNow: "The application is currently free for all accounts.",
          subscriptionPlans: "Subscription plans",
          planStarter: "Starter",
          planPremium: "Premium",
          planElite: "Elite",
          billingMonthly: "Monthly",
          billingYearly: "Yearly",
          subscribeNow: "Subscribe",
          renewSubscription: "Renew",
          currentPlan: "Current plan",
          noActivePlan: "No active subscription",
          daysRemaining: "Days remaining",
          paymentSuccess: "Payment successful",
          paymentFailed: "Payment failed",
          redirectingToPayment: "Redirecting to payment…",
          invoiceHistory: "Invoice history",
          cancelSubscription: "Cancel renewal",
          maxListingsReached: "Listing limit reached for your subscription",

          /* ── Footer ── */
          footerTagline: "Thousands of cars are waiting for you",
          footerBrowseCta: "Browse listings",
          footerDesc: "Morocco's #1 platform to buy and sell used cars. Thousands of verified listings, trusted sellers.",
          navigation: "Navigation",
          categoriesTitle: "Categories",
          contactTitle: "Contact",
          mySpace: "My space",
          favoritesNav: "Favorites",
          companyLocation: "Rabat, Morocco",
          footerCopyright: "© {{year}} Carix. All rights reserved.",
          termsOfService: "Terms of service",
          privacyPolicy: "Privacy policy",
          cookies: "Cookies",

          footerCategories: {
            citadines: "City cars",
            berlines: "Sedans",
            suv4x4: "SUV & 4x4",
            coupes: "Coupes",
            monospaces: "Minivans",
            utilitaires: "Utility vehicles",
            cabriolets: "Convertibles",
            electriques: "Electric",
          },

          /* ── CarDetails page misc ── */
          confirmDeleteContent: "This action cannot be undone.",
          errorOccurred: "An error occurred",
          sessionExpired: "Your session has expired, please log in again",
          listingDeactivated: "Listing deactivated",
          listingActivated: "Listing activated",
          markAsSold: "Mark as sold",
          markAsAvailable: "Mark as available",
          confirmMarkSold: "Mark this listing as sold?",
          confirmMarkAvailable: "Mark this listing as available again?",
          listingMarkedSold: "Listing marked as sold",
          listingMarkedAvailable: "Listing marked as available",
          soldBadge: "Sold",
          history: "History",
          reviews: "reviews",
          promoRemoved: "Promotion removed",
          promoAdded: "Listing put on promotion",
          removePromo: "Remove promo",
          addPromo: "Put on promo",
          verifiedSeller: "Verified seller",
          verifiedBadge: "Verified",
          proSeller: "Professional seller",
          proBadge: "Pro",
          seeSellerProfile: "See profile",
          callBtn: "Call",
          messageSentSuccess: "Message sent ✅",
          messageSentError: "Error sending message ❌",
          newCondition: "New",
          usedCondition: "Used",
          origin: "Origin",
          originCleared: "Customs cleared",
          originWW: "Temporary import (WW) in Morocco",
          originNotCleared: "Not customs cleared yet",
          originImportedNew: "Imported new",
          loadingListing: "Loading listing...",
          promotionBadge: "Promotion",
          noEquipmentAvailable: "No equipment available",
          boostListing: "Boost listing",
          confirmAndPay: "Confirm and pay",
          boostConfirmMessage: "Feature your listing for {{days}} days for {{price}} MAD.",
          boostedUntil: "Boosted until {{date}}",

          /* ── Dictionaries for database-driven content ── */
          colorNames: {
            Blanc: "White", Noir: "Black", Gris: "Grey", Argent: "Silver",
            Rouge: "Red", Bleu: "Blue", "Bleu ciel": "Sky blue", Vert: "Green",
            Beige: "Beige", Marron: "Brown", Orange: "Orange", Jaune: "Yellow",
            Violet: "Purple", Rose: "Pink",
          },
          paintTypes: {
            "Métallisée": "Metallic", "Nacrée": "Pearlescent", "Unie": "Solid", "Mat": "Matte",
          },
          interiorMaterials: {
            "Cuir": "Leather", "Tissu": "Fabric", "Alcantara": "Alcantara", "Mixte": "Mixed",
          },
          equipmentCategories: {
            "Confort": "Comfort", "Sécurité": "Safety", "Multimédia": "Multimedia",
            "Extérieur": "Exterior", "Technologie": "Technology", "Autres": "Other",
          },
          equipmentNames: {
            "Climatisation": "Air conditioning",
            "Climatisation automatique": "Automatic air conditioning",
            "Sièges électriques": "Electric seats",
            "Sièges chauffants": "Heated seats",
            "Démarrage sans clé": "Keyless start",
            "Vitres électriques": "Electric windows",
            "Vitres teintées": "Tinted windows",
            "Apple CarPlay": "Apple CarPlay",
            "Android Auto": "Android Auto",
            "Régulateur de vitesse": "Cruise control",
            "GPS / Navigation": "GPS / Navigation",
            "Caméra de recul": "Rear camera",
            "Radar de recul": "Parking sensors",
            "Toit ouvrant": "Sunroof",
            "Jantes aluminium": "Alloy wheels",
            "ABS": "ABS",
            "ESP": "ESP",
            "Airbags": "Airbags",
            "Bluetooth": "Bluetooth",
            "Attelage remorque": "Tow hitch",
            "Verrouillage centralisé": "Central locking",
            "Aide au stationnement": "Parking assist",
            "Capteurs de pluie": "Rain sensors",
            "Phares LED": "LED headlights",
            "Phares Xénon": "Xenon headlights",
            "Volant multifonction": "Multifunction steering wheel",
            "Ordinateur de bord": "Trip computer",
            "Alarme": "Alarm",
            "Accès sans clé": "Keyless entry",
            "Rétroviseurs électriques": "Electric mirrors",
            "Toit panoramique": "Panoramic roof",
            "Volant chauffant": "Heated steering wheel",
            "Attelage": "Tow bar",
            "Barre de toit": "Roof bars",
            "Jantes alliage": "Alloy wheels",
            "Phares adaptatifs": "Adaptive headlights",
            "Phares Full LED": "Full LED headlights",
            "Rétroviseurs rabattables électriquement": "Electrically folding mirrors",
            "Spoiler": "Spoiler",
            "Caméra 360°": "360° camera",
            "Chargeur sans fil": "Wireless charger",
            "Connexion Wi-Fi": "Wi-Fi connection",
            "Écran tactile": "Touchscreen",
            "Prise USB": "USB port",
            "Système audio premium": "Premium audio system",
            "Airbag conducteur": "Driver airbag",
            "Airbag passager": "Passenger airbag",
            "Airbags latéraux": "Side airbags",
            "Alerte franchissement de ligne": "Lane departure warning",
            "Assistance freinage d'urgence": "Emergency brake assist",
            "Capteurs de stationnement arrière": "Rear parking sensors",
            "Capteurs de stationnement avant": "Front parking sensors",
            "Limiteur de vitesse": "Speed limiter",
          },

          /* ── Admin dashboard ── */
          adminOverviewNav: "Overview",
          adminVerificationsNav: "Verifications",
          adminUsersNav: "Users",
          adminCarsNav: "Listings",
          adminPanel: "Administration",
          totalUsers: "Total users",
          totalParticuliers: "Individuals",
          totalProfessionnels: "Professionals",
          pendingVerifications: "Pending verifications",
          totalMessagesStat: "Total messages",
          noVerificationRequests: "No verification requests",
          requestedOn: "Requested on",
          approve: "Approve",
          reject: "Reject",
          rejectReasonPrompt: "Rejection reason (optional)",
          verificationApproved: "Request approved",
          verificationRejected: "Request rejected",
          searchUser: "Search a user...",
          allRoles: "All roles",
          userColumn: "User",
          roleColumn: "Role",
          verifiedColumn: "Verified",
          bannedColumn: "Banned",
          listingsColumn: "Listings",
          ban: "Ban",
          unban: "Unban",
          confirmBan: "Ban this user?",
          confirmBanContent: "They will not be able to log in until unbanned.",
          confirmUnban: "Unban this user?",
          userBanned: "User banned",
          userUnbanned: "User unbanned",
          roleUpdated: "Role updated",
          resetPassword: "Reset password",
          resetPasswordFor: "Reset password for {{name}}",
          newPassword: "New password",
          passwordResetSuccess: "Password reset successfully",
          passwordResetError: "Error resetting password",
          changeEmail: "Change email",
          changeEmailFor: "Change email for {{name}}",
          newEmail: "New email",
          emailChangedSuccess: "Email updated successfully",
          emailChangedError: "Error changing email",
          allCarsAdmin: "All listings",
          unauthorizedTitle: "Access denied",
          unauthorizedDesc: "You do not have the required permissions to access this page.",
          backToHome: "Back to home",

          fuelTypes: {
            Essence: "Petrol",
            Diesel: "Diesel",
            Hybride: "Hybrid",
            Electrique: "Electric"
          },

          transmissions: {
            Manuelle: "Manual",
            Automatique: "Automatic"
          },

          sellerTypes: {
            Particulier: "Individual",
            Professionnel: "Professional",
            Admin: "Admin"
          },

          bodyTypes: {
            Berline: "Sedan",
            SUV: "SUV",
            "Coupé": "Coupe",
            Break: "Station Wagon",
            Cabriolet: "Convertible",
            Monospace: "Minivan",
            "Pick-up": "Pick-up",
            Citadine: "City Car"
}

        }
      },

      ar: {
        translation: {
          home: "الرئيسية",
          buyCar: "شراء سيارة",
          sellCar: "بيع",
          featuredCars: "السيارات المميزة",
          cars: "السيارات",
          login: "تسجيل الدخول",
          loginOut: "تسجيل الخروج",
          register: "إنشاء حساب",
          offers: "إعلانات",
          promoUsedCars: "سيارات مستعملة في عرض ترويجي",
          sort: "ترتيب",
          contactSeller: "الاتصال بالبائع",
          mileage: "عدد الكيلومترات",
          transmission: "ناقل الحركة",
          year: "السنة",
          searchByBrand: "البحث حسب العلامة التجارية",
          fuelType: "نوع الوقود",
          power: "القوة",
          currency: "درهم",
          seller: "البائع",
          price: "السعر",
          publishedOn: "منذ",
          status: "الحالة",
          phoneNumber: "رقم الهاتف",
          loading: "جار التحميل...",
          noCarsFound: "لم يتم العثور على سيارات",
          noResults: "لا توجد نتائج",
          allBrands: "جميع العلامات التجارية",
          allModels: "جميع الموديلات",
          allGenerations: "جميع الأجيال",
          standardResults: "النتائج العادية",
          priceAscending: "السعر تصاعديًا",
          priceDescending: "السعر تنازليًا",
          mostRecent: "الأحدث",
          lowMileage: "أقل كيلومترات",
          veryGoodPrice: "سعر ممتاز",
          priceNotSpecified: "السعر غير محدد",
          messageBtn: "رسالة",
          postedToday: "اليوم",
          postedYesterday: "أمس",
          postedDaysAgo: "قبل {{count}} أيام",
          postedOneWeekAgo: "قبل أسبوع واحد",
          postedWeeksAgo: "قبل {{count}} أسابيع",
          postedOneMonthAgo: "قبل شهر واحد",
          postedMonthsAgo: "قبل {{count}} أشهر",
          resetPassword: "إعادة تعيين كلمة المرور",
          sendResetLink: "إرسال رابط إعادة التعيين",
          resetPasswordSuccess:
            "إذا كان البريد موجودًا فستصلك رسالة إعادة التعيين.",
          forgotPasswordError:
            "فشل إرسال رابط إعادة التعيين",
          diesel: "ديزل",
          for: "لـ",
          share: "مشاركة",
          print: "طباعة",
          listingNumber: "رقم الإعلان",
          basicData: "البيانات الأساسية",
          vehicleHistory: "تاريخ السيارة",
          technicalSpecs: "المواصفات التقنية",
          colorsInterior: "الألوان والتجهيز الداخلي",
          bodyType: "نوع الهيكل",
          motoType: "نوع الدراجة النارية",
          utilitaireBodyType: "نوع الهيكل",
          payloadCapacity: "الحمولة القصوى",
          cargoVolume: "الحجم المفيد",
          vehicleType: "نوع المركبة",
          condition: "الحالة",
          doors: "عدد الأبواب",
          warranty: "الضمان",
          previousOwners: "عدد المالكين السابقين",
          smoker: "مدخن",
          engineCapacity: "سعة المحرك",
          gears: "عدد السرعات",
          exteriorColor: "اللون الخارجي",
          paintType: "نوع الطلاء",
          interiorColor: "اللون الداخلي",
          interior: "الداخلية",
          equipment: "التجهيزات",
          images: "الصور",
          yourName: "اسمك",
          yourEmail: "بريدك الإلكتروني",
          yourPhone: "رقم هاتفك",
          acceptData: "أوافق على معالجة بياناتي",
          brand: "العلامة التجارية",
          model: "الموديل",
          generation: "الجيل",
          popularBrands: "العلامات التجارية الشائعة",
          maxPrice: "السعر الأقصى (درهم)",
          selectMaxPrice: "اختر السعر الأقصى",
          firstRegistration: "أول تسجيل",
          results: "نتائج",
          browseBy: "تصفح حسب",
          topBrands: "العلامات الشائعة",
          heroTitle: "ابحث عن سيارتك المثالية",
          heroSub: "آلاف الإعلانات الموثقة في المغرب",
          vehicleTypes: {
            cars: "سيارات",
            caravans: "عربات كارافان",
            vans: "مركبات تجارية",
            trucks: "شاحنات",
            trailers: "مقطورات",
            motorcycles: "دراجات نارية",
            comingSoon: "قريباً",
          },
          otherBrands: "ماركات أخرى",
          searchBtn: "بحث",
          seeResults: "عرض {{count}} إعلان",
          seeResultsPlural: "عرض {{count}} إعلانات",
          languageChanged: "تم تغيير اللغة",
          searchByBodyType: "البحث حسب نوع الهيكل",
          citadine: "سيارة صغيرة",
          suv: "دفع رباعي",
          pickup: "بيك أب",
          utility: "سيارة نفعية",
          convertible: "مكشوفة",
          or: "أو",
          minivan: "ميني فان",
          sedan: "سيدان",
          stationWagon: "ستيشن",
          coupe: "كوبيه",
          resultsLoading: "جارٍ تحميل النتائج...",
          defaultContactMessage: `مرحبًا،

          أنا مهتم بهذه السيارة. هل ما زالت متوفرة؟

          مع تحياتي،`,
          km: "كم",
          hp: "حصان",
          loginWith: "تسجيل الدخول بواسطة",
          emailAddress: "البريد الإلكتروني",
          password: "كلمة المرور",
          forgotPassword: "هل نسيت كلمة المرور؟",
          dontHaveAccount: "ليس لديك حساب؟",
          signUp: "إنشاء حساب",
          signUpWithGoogle: "إنشاء حساب عبر Google",
          signUpWithFacebook: "إنشاء حساب عبر Facebook",
          completeYourProProfile: "تم إنشاء الحساب! أكمل ملفك المهني ليتمكن المشترون من إيجادك.",
          facebookLoginCancelled: "تم إلغاء تسجيل الدخول عبر Facebook.",
          facebookLoginFailed: "فشل تسجيل الدخول عبر Facebook. إذا كان التطبيق لا يزال في وضع التطوير، تأكد من إضافة حسابك كمُختبِر.",
          missingToken: "التوكن مفقود",
          loginFailed: "البريد الإلكتروني أو كلمة المرور غير صالحة",
          createAccount: "إنشاء حساب",
          fullName: "الاسم الكامل",
          alreadyHaveAccount: "لديك حساب بالفعل؟",
          passwordNotMatch: "كلمتا المرور غير متطابقتين",
          registerSuccess: "تم إنشاء الحساب بنجاح",
          registerError: "فشل إنشاء الحساب",
          emailAlreadyExists: "يوجد حساب بالفعل بهذا البريد الإلكتروني.",
          goToLogin: "تسجيل الدخول",
          passwordRequirements: "6 أحرف على الأقل.",
          passwordTooWeak: "كلمة مرور غير صالحة: ",
          companyName: "اسم الشركة",
          profileTitle: "ملفي الشخصي",
          addPhoto: "إضافة صورة",
          changePhoto: "تغيير الصورة",
          coverPhoto: "صورة الغلاف",
          addCoverPhoto: "إضافة صورة الغلاف",
          changeCoverPhoto: "تغيير صورة الغلاف",
          save: "حفظ",
          requiredFields: "يرجى ملء جميع الحقول المطلوبة، بما في ذلك صورة الغلاف.",
          profileUpdated: "تم تحديث الملف الشخصي",
          updateError: "خطأ في تحديث الملف الشخصي",
          username: "اسم المستخدم",
          city: "المدينة",
          particulier: "مستعمل",
          professionnel: "شركة",
          newPassword: "كلمة المرور الجديدة",
          confirmPassword: "تأكيد كلمة المرور",
          passwordResetSuccess:
            "تمت إعادة تعيين كلمة المرور بنجاح",
          resetPasswordFailed:
            "فشل إعادة تعيين كلمة المرور",
          backToLogin: "العودة إلى تسجيل الدخول",
          yes: "نعم",
          no: "لا",

          /* ── Dashboard / MyCars ── */
          resetFilters: "إعادة تعيين الفلاتر",
          myListings: "إعلاناتي",
          newListing: "إعلان جديد",
          search: "بحث...",
          allTypes: "كل الأنواع",
          allStatus: "الكل",
          activeStatus: "النشطة",
          inactiveStatus: "المعطلة",
          listingDeleted: "تم حذف الإعلان",
          confirmDelete: "هل أنت متأكد من حذف هذا الإعلان؟",
          totalListings: "إجمالي الإعلانات",
          activeListingsCount: "الإعلانات النشطة",
          totalViews: "إجمالي المشاهدات",
          messages: "الرسائل",
          carColumn: "السيارة",
          views: "المشاهدات",
          actions: "الإجراءات",
          seeListing: "عرض الإعلان",
          edit: "تعديل",
          deactivate: "تعطيل",
          activate: "تفعيل",
          delete: "حذف",
          activeLabel: "نشط",
          inactiveLabel: "معطل",
          notifications: "الإشعارات",
          noNotifications: "لا توجد إشعارات",
          dashboard: "لوحة التحكم",
          addListing: "إضافة إعلان",
          statisticsNav: "الإحصائيات",
          settings: "الإعدادات",
          settingsComingSoon: "الإعدادات ستكون متاحة قريبًا...",
          statisticsViews: "إحصائيات المشاهدات",
          myFavorites: "المفضلة",
          chat: "الدردشة",
          myAccount: "حسابي",
          headerMyListings: "إعلاناتي",
          headerFavorites: "المفضلة",
          headerProfile: "الملف الشخصي",
          previous: "السابق",
          next: "التالي",
          professionalSellers: "البائعون المحترفون",
          seeProfile: "عرض الملف",
          carsListed: "إعلانات",
          description: "الوصف",
          descriptionPlaceholder: "صف نشاطك وخدماتك...",
          chooseLocation: "اختر موقعك",
          myLocation: "موقعي",
          locating: "جارٍ التحديد...",
          searchAddress: "ابحث عن عنوان...",
          confirm: "تأكيد",
          cancel: "إلغاء",
          clickAddPhotos: "انقر لإضافة صور",
          editBackground: "تعديل الخلفية",
          noFavorites: "لا توجد مفضلات بعد",
          removeFavorite: "إزالة من المفضلة",
          addToFavorites: "إضافة إلى المفضلة",
          removeFromFavorites: "إزالة من المفضلة",
          noMessages: "لا توجد رسائل بعد",
          selectConversation: "اختر محادثة",
          typeMessage: "اكتب رسالة...",
          noDataYet: "لا توجد بيانات بعد",

          /* ── PromoCars ── */
          promoLabel: "مُعزّز",
          promoCarsTitle: "إعلانات معزّزة",
          seeAllListings: "عرض جميع الإعلانات",
          promoCardCta: "عرض الإعلان",
          latestListingsLabel: "نُشرت حديثًا",
          latestListingsTitle: "أحدث الإعلانات",
          statsListings: "إعلانات نشطة",
          statsSellers: "بائعون مسجلون",
          statsCities: "مدن مغطاة",

          /* ── NewCars / Why section ── */
          ourAdvantages: "مميزاتنا",
          whyChooseUs: "لماذا تختار Carix؟",
          whyChooseUsSub: "المنصة الأكثر اكتمالاً لشراء وبيع سيارتك في المغرب.",
          feature1Title: "بحث ذكي",
          feature1Desc: "قم بالتصفية حسب العلامة التجارية، الموديل، نوع الهيكل، الكيلومترات، السعر والمزيد. اعثر على ما تبحث عنه بنقرات قليلة.",
          feature2Title: "إعلانات موثقة",
          feature2Desc: "كل بائع موثق وكل إعلان مراجع. اشترِ بثقة بفضل نظام التحقق لدينا.",
          feature3Title: "تواصل مباشر",
          feature3Desc: "تواصل مباشرة مع البائع عبر نظام المراسلة المدمج. لا وسيط، لا عمولة مخفية.",
          feature4Title: "نشر سريع",
          feature4Desc: "انشر إعلانك في أقل من 5 دقائق بفضل النموذج الإرشادي. صورك تُحسَّن تلقائياً.",

          /* ── Reviews / Testimonials ── */
          testimonialsLabel: "آراء المستخدمين",
          testimonialsTitle: "ماذا يقول مستخدمونا",
          member: "عضو",
          testimonialsSub: "منصة مصممة لجعل شراء وبيع السيارات أمرًا بسيطًا وموثوقًا.",
          statListingsPublished: "إعلانات منشورة",
          statBuyersSatisfied: "مشترون راضون",
          statAverageRating: "التقييم المتوسط",
          statSatisfactionRate: "معدل الرضا",

          /* ── Misc ── */
          verifiedPartners: "شركاء موثوقون",
          promoToggleTitle: "عرض خاص / ترويج",
          promoToggleDesc: "سيتم إبراز إعلانك في قسم \"العروض الخاصة\" مع شارة ترويجية.",
          recentlyViewed: "شوهدت مؤخرًا",

          /* ── Login / Register page ── */
          loginSubtitle: "ادخل إلى حسابك في Carix",
          loginHeroBadge: "المنصة الأولى في المغرب",
          loginHeroTitle: "اشترِ وبِع سيارتك بسهولة",
          loginHeroSub: "انضم إلى آلاف الأفراد والمهنيين الذين يثقون بـ Carix.",
          loginHeroFeature1: "+50,000 سيارة متاحة",
          loginHeroFeature2: "مراسلة آمنة ومدمجة",
          loginHeroFeature3: "إعلانات موثوقة ومدققة",
          heroStatListings: "إعلانات",
          heroStatBuyers: "مشترين",
          heroStatSatisfaction: "رضا",
          heroLaunchMessage: "منصة أُطلقت حديثًا — كن من أوائل المنضمين إلى Carix وانشر إعلانك.",

          registerSubtitle: "اختر نوع حسابك",
          particulierDesc: "بائع أو مشتري خاص",
          professionnelDesc: "وكالة أو مرآب",
          sectionInfos: "المعلومات",
          sectionPresentation: "التقديم",
          sectionSecurity: "الأمان",
          sectionLocation: "الموقع",
          sectionPhotos: "الصور",
          profilePhotoLabel: "صورة الملف الشخصي",
          establishmentAddress: "عنوان مؤسستك",

          /* ── ProfilePage ── */
          addressRequired: "حقل العنوان مطلوب.",
          companyNameRequiredForSwitch: "اسم الشركة (حقل \"الاسم الكامل\" أعلاه) مطلوب.",
          switchToProSuccess: "حسابك الآن حساب احترافي!",
          switchToProError: "خطأ أثناء تغيير الحساب",
          myProfileFallback: "ملفي الشخصي",
          personalInfoTitle: "المعلومات الشخصية",
          usernameLabel: "اسم المستخدم",
          addressLabel: "العنوان *",
          fieldRequired: "هذا الحقل مطلوب",
          addressPlaceholder: "أدخل عنوانك...",
          pointLocation: "تحديد الموقع",
          coordinatesLabel: "الإحداثيات:",
          switchToProTitle: "التحول إلى حساب احترافي",
          switchToProDesc: "بع كمحترف: صفحة شركة، وصف عام والوصول إلى أدوات المحترفين. سيُستخدم حقل \"الاسم الكامل\" أعلاه كاسم لشركتك، وسيتم الاحتفاظ بموقعك الحالي وصورة الغلاف. أضف وصفًا لنشاطك أدناه.",
          switchToProFinalNotice: "هذا التغيير نهائي.",
          activityDescriptionLabel: "وصف نشاطك",
          switchingInProgress: "جارٍ التغيير...",
          becomeProfessionalSeller: "كن بائعًا محترفًا",
          accountVerificationTitle: "التحقق من الحساب",
          verifiedAccountBadge: "حساب موثّق",
          verificationPendingBadge: "الطلب قيد المراجعة",
          verificationPendingDesc: "تم استلام طلب التحقق الخاص بك. يقوم فريقنا بمراجعته وسيتواصل معك خلال 48 ساعة عمل — لا حاجة لأي إجراء إضافي من جانبك.",
          verificationRejectedNotice: "لم تتم الموافقة على طلبك السابق.",
          rejectionReasonLabel: "السبب:",
          verificationRejectedHint: "يمكنك تصحيح معلومات ملفك الشخصي أعلاه ثم تقديم طلب جديد.",
          verificationBenefitsDesc: "يعرض الحساب الموثّق شارة ثقة مرئية لبقية المستخدمين، ويعزز مصداقيتك ويزيد عدد جهات الاتصال التي تتلقاها. لمزيد من الأمان، نوصي بتوثيق حسابك قبل نشر إعلاناتك.",
          verificationRequestSentSuccess: "تم إرسال الطلب! سيتواصل معك فريقنا.",
          verificationRequestError: "خطأ أثناء إرسال الطلب",
          resubmitVerificationRequest: "تقديم طلب جديد",
          requestVerificationBtn: "طلب التحقق",

          /* ── SellerProfile ── */
          ratingsCount: "تقييمات",
          previousOwnersLabel: "المالك (المالكون) السابقون",
          seeLess: "عرض أقل",
          seeMore: "عرض المزيد",
          searchFor: "البحث عن",
          carTypeLabel: "سيارة",
          fromLabel: "من",
          toLabel: "إلى",
          yourMessage: "رسالتك",
          sendLabel: "إرسال",
          memberSince: "عضو منذ",
          close: "إغلاق",

          /* ── Settings ── */
          accountDeleteError: "خطأ أثناء حذف حسابك.",
          emailNotifLabel: "إشعارات البريد الإلكتروني",
          emailNotifDesc: "تلقي طلبات الاتصال الجديدة عبر البريد الإلكتروني",
          messageNotifLabel: "إشعارات الرسائل",
          messageNotifDesc: "تلقي تنبيه عند استلام رسائل جديدة",
          promoNotifLabel: "العروض والترويجات",
          promoNotifDesc: "تلقي الأخبار والعروض الخاصة من المنصة",
          securitySection: "الأمان",
          changePasswordLabel: "تغيير كلمة المرور",
          changePasswordDesc: "غيّر كلمة مرورك بانتظام لتأمين حسابك",
          modifyArrowLabel: "تعديل ←",
          editProfileLabel: "تعديل الملف الشخصي",
          editProfileDesc: "تحديث معلوماتك الشخصية وصورة ملفك الشخصي",
          languageSection: "اللغة",
          dangerZoneTitle: "منطقة الخطر",
          deleteAccountLabel: "حذف حسابي",
          deleteAccountDesc: "هذا الإجراء نهائي. سيتم حذف جميع إعلاناتك وبياناتك.",
          deleteAccountConfirmText: "هل أنت متأكد؟ سيؤدي هذا إلى حذف حسابك وجميع إعلاناتك نهائيًا.",
          deletingInProgress: "جارٍ الحذف…",
          confirmAccountDeletion: "تأكيد الحذف",

          /* ── Favorites ── */
          removeFavoriteTitle: "إزالة من المفضلة؟",
          removeFavoriteContent: "ستتم إزالة هذه السيارة من قائمة مفضلاتك.",
          removeLabel: "إزالة",
          listingSingular: "إعلان",
          listingPlural: "إعلانات",
          noFavoritesDesc: "أضف سيارات إلى مفضلاتك لتجدها هنا.",
          browseListings: "تصفح الإعلانات",

          /* ── Header ── */
          userFallback: "مستخدم",
          emailNotConfirmedWarning: "لم يتم تأكيد عنوان بريدك الإلكتروني بعد. تحقق من بريدك الوارد لتفعيل جميع الميزات.",
          emailResent: "تم إعادة إرسال البريد الإلكتروني",
          sendingInProgress: "جارٍ الإرسال...",
          resendConfirmationEmail: "إعادة إرسال بريد التأكيد",

          /* ── MultiStepCarForm ── */
          mainPhoto: "الصورة الرئيسية",
          mainLabel: "رئيسية",
          setAsMainPhoto: "تعيين كصورة رئيسية",
          removeBackground: "إزالة الخلفية",
          confirmDeletePhoto: "حذف هذه الصورة؟",
          photoProcessingError: "خطأ أثناء معالجة الصورة",
          bgCompositionError: "خطأ أثناء تركيب الخلفية",
          bgApplyError: "تعذّر تطبيق هذه الخلفية",
          photoUpdated: "تم تحديث الصورة",
          describeVehiclePlaceholder: "صف مركبتك (الحالة، التاريخ، الخيارات...)",
          generateWithAi: "توليد بالذكاء الاصطناعي",
          descriptionGenerated: "تم إنشاء الوصف!",
          descriptionGenerationError: "خطأ أثناء التوليد",
          listingPublishedSuccess: "تم نشر الإعلان بنجاح!",
          listingPublishError: "خطأ أثناء نشر الإعلان",
          publishListingBtn: "نشر الإعلان",
          publishingInProgress: "جارٍ النشر…",
          noListingToUpdate: "لا يوجد إعلان لتحديثه.",
          listingUpdatedSuccess: "تم تحديث الإعلان",
          errorPrefix: "خطأ:",
          saveChangesBtn: "حفظ التعديلات",
          bgRemovedChooseOption: "تمت إزالة الخلفية — اختر خيارًا",
          withoutBackground: "بدون خلفية",
          withBackground: "بخلفية",
          chooseBackground: "اختر خلفية:",
          customColor: "لون مخصص",
          customPhoto: "صورة مخصصة",
          keepWithoutBackground: "الاحتفاظ بدون خلفية",
          useThisBackground: "استخدام هذه الخلفية",
          mainPhotoSet: "تم تعيين الصورة الرئيسية",

          registerHeroBadgePro: "حساب مهني",
          registerHeroBadgePart: "حساب خاص",
          registerHeroTitlePro: "أدر نشاطك في قطاع السيارات",
          registerHeroTitlePart: "بع سيارتك بنقرات قليلة",
          registerHeroSubPro: "استفد من أدوات مخصصة للوكالات والمرائب: إدارة الأسطول، المراسلة، لوحة التحكم.",
          registerHeroSubPart: "انشر إعلانك مجانًا وتواصل مع آلاف المشترين المحتملين في المغرب.",
          heroPro1: "لوحة تحكم احترافية",
          heroPro2: "إدارة إعلانات متعددة",
          heroPro3: "صفحة عرض وكالتك",
          heroPro4: "إحصائيات الأداء",
          heroPart1: "إعلان مجاني وغير محدود",
          heroPart2: "مراسلة مباشرة مع المشترين",
          heroPart3: "إدارة سهلة لإعلاناتك",
          heroPart4: "نشر الإعلان في أقل من 5 دقائق",

          /* ── AddCars / Sell page ── */
          quickSale: "بيع سريع",
          sellCarHeroTitleLine1: "بِع",
          sellCarHeroTitleLine2: "سيارتك بسهولة",
          sellCarHeroSub: "ملايين المشترين المحتملين في انتظارك على Carix.",
          benefitFree: "نشر مجاني 100%",
          benefitFast: "النشر خلال 5 دقائق",
          benefitVerifiedBuyers: "مشترون موثوقون وجادون",
          benefitSupport: "دعم متوفر 7/7",
          statActiveListings: "إعلانات نشطة",
          statBuyersPerMonth: "مشترين / شهر",
          statFree: "مجاني",
          basicInfo: "المعلومات الأساسية",
          stepOneOfTwo: "الخطوة 1 من 2 — سيارتك",
          selectBrand: "اختر علامة تجارية",
          selectModel: "اختر موديلاً",
          selectBrandFirst: "اختر العلامة التجارية أولاً",
          continueBtn: "متابعة",

          /* ── Video generator ── */
          videoGenTitle: "إنشاء فيديو تقديمي",
          backgroundMusic: "موسيقى خلفية",
          noMusicTracksPrefix: "لا توجد مقاطع متاحة — ضع ملفات mp3. في",
          durationPerPhoto: "المدة لكل صورة",
          generatingInProgress: "جارٍ التنفيذ...",
          generateVideoBtn: "إنشاء الفيديو",
          downloadLocally: "تحميل محليًا",
          addedToListingBtn: "تمت الإضافة إلى الإعلان",
          addingInProgress: "جارٍ الإضافة...",
          addToListingBtn: "إضافة إلى الإعلان",
          preparingPhotos: "تحضير الصور...",
          generatingVideoProgress: "جارٍ إنشاء الفيديو (قد يستغرق 20-30 ثانية)...",
          videoGeneratedSuccess: "تم إنشاء الفيديو بنجاح!",
          unknownError: "خطأ غير معروف",
          videoAddedSuccess: "تمت إضافة الفيديو إلى الإعلان!",
          videoAddError: "خطأ أثناء إضافة الفيديو إلى الإعلان",

          /* ── Credit calculator ── */
          financingSimulator: "محاكي التمويل",
          initialDownPayment: "الدفعة الأولى",
          duration: "المدة",
          monthsLabel: "أشهر",
          annualRate: "المعدل السنوي",
          estimatedMonthlyPayment: "القسط الشهري المقدر",
          perMonth: "/شهر",
          financedAmount: "المبلغ الممول",
          totalInterest: "إجمالي الفوائد",
          totalCreditCost: "التكلفة الإجمالية للتمويل",
          simulationDisclaimer: "محاكاة إرشادية — تواصل مع بنكك للحصول على عرض مخصص.",

          /* ── AI price estimation ── */
          aiPriceEstimation: "تقدير السعر بالذكاء الاصطناعي",
          aiPriceDesc: "يحلل الذكاء الاصطناعي الإعلانات المشابهة لتقييم مدى تنافسية هذا السعر.",
          analyzePrice: "تحليل السعر",
          analyzingInProgress: "جارٍ التحليل...",
          fairPrice: "سعر عادل",
          abovePriceMarket: "{{pct}}% أعلى من السوق",
          belowPriceMarket: "{{pct}}% أقل من السوق",
          listingPrice: "سعر الإعلان",
          estimatedMarketPrice: "السعر المقدر في السوق",
          priceRange: "النطاق السعري",
          retryAnalysis: "إعادة التحليل",
          estimationError: "خطأ {{status}}: {{detail}}",

          /* ── Price history ── */
          priceHistoryTitle: "تاريخ السعر",
          stable: "مستقر",
          today: "اليوم",

          /* ── Chat widget ── */
          contactViaChat: "التواصل عبر الدردشة",
          chatWith: "الدردشة مع {{name}}",
          online: "متصل",
          connecting: "جارٍ الاتصال...",
          startConversation: "أرسل رسالة لبدء المحادثة.",
          yourMessagePlaceholder: "رسالتك...",

          /* ── Compare ── */
          carsCountLabel: "{{count}}/3 سيارات",
          compareBtn: "مقارنة",
          compareTitle: "المقارنة",
          clearAll: "مسح الكل",
          loadingCarDetails: "جارٍ تحميل التفاصيل...",
          noCarsToCompare: "لا توجد سيارات للمقارنة",
          addUpTo3CarsDesc: "أضف حتى 3 سيارات من القائمة أو من صفحات التفاصيل.",
          browseListingsBtn: "تصفح الإعلانات",
          seeListingFull: "عرض الإعلان",
          getAiAdvice: "احصل على نصيحة الذكاء الاصطناعي — ما هو الخيار الأفضل؟",
          aiAdviceTitle: "نصيحة الذكاء الاصطناعي — AutoMarket",
          bestChoice: "الخيار الأفضل",
          quality: "الجودة",
          overallScore: "التقييم الإجمالي",
          recommendationLabel: "توصيتنا",
          aiServiceUnavailable: "خدمة الذكاء الاصطناعي غير متوفرة.",

          /* ── Search alert ── */
          alertTooltip: "إنشاء تنبيه لهذه الفلاتر",
          alertOnFilters: "تنبيه على هذه الفلاتر",
          createAlertBtn: "إنشاء تنبيه",
          alertDesc: "استلم بريدًا إلكترونيًا بمجرد ظهور إعلان يطابق معاييرك الحالية",
          emailOptionalPlaceholder: "البريد الإلكتروني (اختياري، يستخدم بريد الحساب)",
          creatingInProgress: "جارٍ الإنشاء...",
          createAlertSubmit: "إنشاء التنبيه",
          alertCreatedSuccess: "تم إنشاء التنبيه! ستصلك إشعارات عبر البريد الإلكتروني.",
          alertCreateError: "خطأ أثناء إنشاء التنبيه",

          /* ── Dashboard / PageLoader ── */
          dashboardProTitle: "لوحة التحكم الاحترافية",
          marketplaceTagline: "سوق السيارات",

          /* ── الاشتراكات ── */
          mySubscription: "اشتراكي",
          comingSoon: "قريباً",
          freeForNow: "التطبيق مجاني حالياً لجميع الحسابات.",
          subscriptionPlans: "خطط الاشتراك",
          planStarter: "Starter",
          planPremium: "Premium",
          planElite: "Elite",
          billingMonthly: "شهري",
          billingYearly: "سنوي",
          subscribeNow: "اشترك الآن",
          renewSubscription: "تجديد",
          currentPlan: "الخطة الحالية",
          noActivePlan: "لا يوجد اشتراك نشط",
          daysRemaining: "الأيام المتبقية",
          paymentSuccess: "تم الدفع بنجاح",
          paymentFailed: "فشلت عملية الدفع",
          redirectingToPayment: "جارٍ التحويل إلى صفحة الدفع…",
          invoiceHistory: "سجل الفواتير",
          cancelSubscription: "إلغاء التجديد",
          maxListingsReached: "تم بلوغ الحد الأقصى للإعلانات ضمن اشتراكك",

          /* ── Footer ── */
          footerTagline: "آلاف السيارات في انتظارك",
          footerBrowseCta: "تصفح الإعلانات",
          footerDesc: "المنصة الأولى في المغرب لبيع وشراء السيارات المستعملة. آلاف الإعلانات الموثقة، وبائعون موثوقون.",
          navigation: "التنقل",
          categoriesTitle: "الفئات",
          contactTitle: "تواصل معنا",
          mySpace: "مساحتي",
          favoritesNav: "المفضلة",
          companyLocation: "القنيطرة، المغرب",
          footerCopyright: "© {{year}} Carix. جميع الحقوق محفوظة.",
          termsOfService: "شروط الاستخدام",
          privacyPolicy: "سياسة الخصوصية",
          cookies: "ملفات تعريف الارتباط",

          footerCategories: {
            citadines: "سيارات صغيرة",
            berlines: "سيدان",
            suv4x4: "دفع رباعي",
            coupes: "كوبيه",
            monospaces: "ميني فان",
            utilitaires: "سيارات نفعية",
            cabriolets: "مكشوفة",
            electriques: "كهربائية",
          },

          /* ── CarDetails page misc ── */
          confirmDeleteContent: "هذا الإجراء لا يمكن التراجع عنه.",
          errorOccurred: "حدث خطأ",
          sessionExpired: "انتهت صلاحية جلستك، يرجى تسجيل الدخول مرة أخرى",
          listingDeactivated: "تم تعطيل الإعلان",
          listingActivated: "تم تفعيل الإعلان",
          markAsSold: "وضع علامة \"تم البيع\"",
          markAsAvailable: "إعادة الإعلان للبيع",
          confirmMarkSold: "هل تريد وضع علامة \"تم البيع\" على هذا الإعلان؟",
          confirmMarkAvailable: "هل تريد إعادة هذا الإعلان للبيع؟",
          listingMarkedSold: "تم وضع علامة \"تم البيع\" على الإعلان",
          listingMarkedAvailable: "تمت إعادة الإعلان للبيع",
          soldBadge: "مباع",
          history: "السجل",
          reviews: "تقييمات",
          promoRemoved: "تمت إزالة الترويج",
          promoAdded: "تم وضع الإعلان في العروض",
          removePromo: "إزالة الترويج",
          addPromo: "وضع في العروض",
          verifiedSeller: "بائع موثق",
          verifiedBadge: "موثق",
          proSeller: "بائع محترف",
          proBadge: "محترف",
          seeSellerProfile: "عرض الملف الشخصي",
          callBtn: "اتصال",
          messageSentSuccess: "تم إرسال الرسالة ✅",
          messageSentError: "خطأ في الإرسال ❌",
          newCondition: "جديد",
          usedCondition: "مستعملة",
          origin: "الأصل",
          originCleared: "مُفرغة الجمارك",
          originWW: "استيراد مؤقت (WW) بالمغرب",
          originNotCleared: "لم يتم تفريغها من الجمارك بعد",
          originImportedNew: "مستوردة جديدة",
          loadingListing: "جارٍ تحميل الإعلان...",
          promotionBadge: "عرض ترويجي",
          noEquipmentAvailable: "لا توجد تجهيزات متاحة",
          boostListing: "تعزيز الإعلان",
          confirmAndPay: "تأكيد والدفع",
          boostConfirmMessage: "أبرز إعلانك لمدة {{days}} يومًا مقابل {{price}} درهم.",
          boostedUntil: "معزّز حتى {{date}}",

          /* ── Dictionaries for database-driven content ── */
          colorNames: {
            Blanc: "أبيض", Noir: "أسود", Gris: "رمادي", Argent: "فضي",
            Rouge: "أحمر", Bleu: "أزرق", "Bleu ciel": "أزرق سماوي", Vert: "أخضر",
            Beige: "بيج", Marron: "بني", Orange: "برتقالي", Jaune: "أصفر",
            Violet: "بنفسجي", Rose: "وردي",
          },
          paintTypes: {
            "Métallisée": "معدني", "Nacrée": "لؤلؤي", "Unie": "لون واحد", "Mat": "مطفي",
          },
          interiorMaterials: {
            "Cuir": "جلد", "Tissu": "قماش", "Alcantara": "ألكانتارا", "Mixte": "مختلط",
          },
          equipmentCategories: {
            "Confort": "الراحة", "Sécurité": "الأمان", "Multimédia": "الوسائط المتعددة",
            "Extérieur": "الخارج", "Technologie": "التكنولوجيا", "Autres": "أخرى",
          },
          equipmentNames: {
            "Climatisation": "تكييف الهواء",
            "Climatisation automatique": "تكييف أوتوماتيكي",
            "Sièges électriques": "مقاعد كهربائية",
            "Sièges chauffants": "مقاعد مدفأة",
            "Démarrage sans clé": "تشغيل بدون مفتاح",
            "Vitres électriques": "نوافذ كهربائية",
            "Vitres teintées": "نوافذ مظللة",
            "Apple CarPlay": "Apple CarPlay",
            "Android Auto": "Android Auto",
            "Régulateur de vitesse": "مثبت السرعة",
            "GPS / Navigation": "نظام الملاحة GPS",
            "Caméra de recul": "كاميرا الرجوع للخلف",
            "Radar de recul": "حساسات الرجوع للخلف",
            "Toit ouvrant": "فتحة سقف",
            "Jantes aluminium": "جنوط ألمنيوم",
            "ABS": "نظام ABS",
            "ESP": "نظام ESP",
            "Airbags": "وسائد هوائية",
            "Bluetooth": "بلوتوث",
            "Attelage remorque": "مقطورة جر",
            "Verrouillage centralisé": "إغلاق مركزي",
            "Aide au stationnement": "مساعد الركن",
            "Capteurs de pluie": "حساسات المطر",
            "Phares LED": "مصابيح LED",
            "Phares Xénon": "مصابيح زينون",
            "Volant multifonction": "مقود متعدد الوظائف",
            "Ordinateur de bord": "حاسوب الرحلة",
            "Alarme": "نظام إنذار",
            "Accès sans clé": "دخول بدون مفتاح",
            "Rétroviseurs électriques": "مرايا كهربائية",
            "Toit panoramique": "سقف بانورامي",
            "Volant chauffant": "مقود مدفأ",
            "Attelage": "خطاف جر",
            "Barre de toit": "حاملة سقف",
            "Jantes alliage": "جنوط سبيكة",
            "Phares adaptatifs": "مصابيح تكيفية",
            "Phares Full LED": "مصابيح LED كاملة",
            "Rétroviseurs rabattables électriquement": "مرايا قابلة للطي كهربائيًا",
            "Spoiler": "سبويلر",
            "Caméra 360°": "كاميرا 360°",
            "Chargeur sans fil": "شاحن لاسلكي",
            "Connexion Wi-Fi": "اتصال واي فاي",
            "Écran tactile": "شاشة لمس",
            "Prise USB": "منفذ USB",
            "Système audio premium": "نظام صوت متميز",
            "Airbag conducteur": "وسادة هوائية للسائق",
            "Airbag passager": "وسادة هوائية للراكب",
            "Airbags latéraux": "وسائد هوائية جانبية",
            "Alerte franchissement de ligne": "تنبيه مغادرة المسار",
            "Assistance freinage d'urgence": "مساعد الفرملة الطارئة",
            "Capteurs de stationnement arrière": "حساسات ركن خلفية",
            "Capteurs de stationnement avant": "حساسات ركن أمامية",
            "Limiteur de vitesse": "محدد السرعة",
          },

          /* ── Admin dashboard ── */
          adminOverviewNav: "نظرة عامة",
          adminVerificationsNav: "طلبات التوثيق",
          adminUsersNav: "المستخدمون",
          adminCarsNav: "الإعلانات",
          adminPanel: "الإدارة",
          totalUsers: "إجمالي المستخدمين",
          totalParticuliers: "الأفراد",
          totalProfessionnels: "المهنيون",
          pendingVerifications: "طلبات توثيق معلقة",
          totalMessagesStat: "إجمالي الرسائل",
          noVerificationRequests: "لا توجد طلبات توثيق",
          requestedOn: "تاريخ الطلب",
          approve: "الموافقة",
          reject: "الرفض",
          rejectReasonPrompt: "سبب الرفض (اختياري)",
          verificationApproved: "تمت الموافقة على الطلب",
          verificationRejected: "تم رفض الطلب",
          searchUser: "البحث عن مستخدم...",
          allRoles: "جميع الأدوار",
          userColumn: "المستخدم",
          roleColumn: "الدور",
          verifiedColumn: "موثق",
          bannedColumn: "محظور",
          listingsColumn: "الإعلانات",
          ban: "حظر",
          unban: "إلغاء الحظر",
          confirmBan: "هل تريد حظر هذا المستخدم؟",
          confirmBanContent: "لن يتمكن من تسجيل الدخول حتى يتم إلغاء الحظر.",
          confirmUnban: "هل تريد إلغاء حظر هذا المستخدم؟",
          userBanned: "تم حظر المستخدم",
          userUnbanned: "تم إلغاء حظر المستخدم",
          roleUpdated: "تم تحديث الدور",
          resetPassword: "إعادة تعيين كلمة المرور",
          resetPasswordFor: "إعادة تعيين كلمة مرور {{name}}",
          newPassword: "كلمة المرور الجديدة",
          passwordResetSuccess: "تمت إعادة تعيين كلمة المرور بنجاح",
          passwordResetError: "خطأ أثناء إعادة تعيين كلمة المرور",
          changeEmail: "تغيير البريد الإلكتروني",
          changeEmailFor: "تغيير البريد الإلكتروني لـ {{name}}",
          newEmail: "البريد الإلكتروني الجديد",
          emailChangedSuccess: "تم تحديث البريد الإلكتروني بنجاح",
          emailChangedError: "خطأ أثناء تغيير البريد الإلكتروني",
          allCarsAdmin: "جميع الإعلانات",
          unauthorizedTitle: "الوصول مرفوض",
          unauthorizedDesc: "ليس لديك الصلاحيات اللازمة للوصول إلى هذه الصفحة.",
          backToHome: "العودة إلى الرئيسية",

          fuelTypes: {
            Essence: "بنزين",
            Diesel: "ديزل",
            Hybride: "هجين",
            Electrique: "كهربائي"
          },

          transmissions: {
            Manuelle: "يدوي",
            Automatique: "أوتوماتيك"
          },

          sellerTypes: {
            Particulier: "فرد",
            Professionnel: "مهني",
            Admin: "مشرف"
          },

          bodyTypes: {
            Berline: "سيدان",
            SUV: "دفع رباعي",
            "Coupé": "كوبيه",
            Break: "ستيشن",
            Cabriolet: "مكشوفة",
            Monospace: "ميني فان",
            "Pick-up": "بيك أب",
            Citadine: "سيارة صغيرة"
}

        }
      }

    },

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;